/* 🤖 this file was generated by svg-to-ts */
export const iconAdd16: {
  name: 'add-16';
  data: string;
} = {
  name: 'add-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M7.997 2.708c.346 0 .625.28.625.625v4.042h4.042a.625.625 0 1 1 0 1.25H8.622v4.042a.625.625 0 1 1-1.25 0V8.625H3.331a.625.625 0 1 1 0-1.25h4.041V3.333c0-.345.28-.625.625-.625"/></svg>`,
};
export const iconAdd24: {
  name: 'add-24';
  data: string;
} = {
  name: 'add-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12 4.25a.75.75 0 0 1 .75.75v6.25H19a.75.75 0 0 1 0 1.5h-6.25V19a.75.75 0 0 1-1.5 0v-6.25H5a.75.75 0 0 1 0-1.5h6.25V5a.75.75 0 0 1 .75-.75"/></svg>`,
};
export const iconAddManually24: {
  name: 'add-manually-24';
  data: string;
} = {
  name: 'add-manually-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M4.25 6A.75.75 0 0 1 5 5.25h14a.75.75 0 0 1 0 1.5H5A.75.75 0 0 1 4.25 6m0 4A.75.75 0 0 1 5 9.25h14a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m0 4a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75m13.75.25a.75.75 0 0 1 .75.75v2.25H21a.75.75 0 0 1 0 1.5h-2.25V21a.75.75 0 0 1-1.5 0v-2.25H15a.75.75 0 0 1 0-1.5h2.25V15a.75.75 0 0 1 .75-.75M4.25 18a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconAddUser24: {
  name: 'add-user-24';
  data: string;
} = {
  name: 'add-user-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24"><path fill-rule="evenodd" d="M7.339 3.141a4.75 4.75 0 1 1 6.717 6.718A4.75 4.75 0 0 1 7.34 3.14Zm3.358.109a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m-2 12a3.25 3.25 0 0 0-3.25 3.25v2a.75.75 0 0 1-1.5 0v-2a4.75 4.75 0 0 1 4.75-4.75h4a.75.75 0 0 1 0 1.5zm9-.5a.75.75 0 0 1 .75.75v2.25h2.25a.75.75 0 0 1 0 1.5h-2.25v2.25a.75.75 0 0 1-1.5 0v-2.25h-2.25a.75.75 0 0 1 0-1.5h2.25V15.5a.75.75 0 0 1 .75-.75"/></svg>`,
};
export const iconArchive16: {
  name: 'archive-16';
  data: string;
} = {
  name: 'archive-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16"><path fill-rule="evenodd" d="M2.63 2.74a.875.875 0 1 0 0 1.75h10.5a.875.875 0 1 0 0-1.75zm-1.502-.628a2.13 2.13 0 0 1 1.502-.623h10.5a2.125 2.125 0 0 1 .625 4.157v6.968a2.125 2.125 0 0 1-2.125 2.125h-7.5a2.125 2.125 0 0 1-2.125-2.125V5.646a2.125 2.125 0 0 1-.877-3.534m2.127 3.627v6.875a.875.875 0 0 0 .875.875h7.5a.875.875 0 0 0 .875-.875V5.74h-9.25Zm2.5 2.375c0-.345.28-.625.625-.625h3a.625.625 0 0 1 0 1.25h-3a.625.625 0 0 1-.625-.625"/></svg>`,
};
export const iconArrowDown16: {
  name: 'arrow-down-16';
  data: string;
} = {
  name: 'arrow-down-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.97 5.22a.75.75 0 0 1 1.06 0L8 9.19l3.97-3.97a.75.75 0 1 1 1.06 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 0-1.06"/></svg>`,
};
export const iconArrowRight16: {
  name: 'arrow-right-16';
  data: string;
} = {
  name: 'arrow-right-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M9.85 5.183a.625.625 0 0 1 .884 0L13.4 7.85a.625.625 0 0 1 0 .884L10.734 11.4a.625.625 0 1 1-.884-.884l1.6-1.6H3.624a.625.625 0 0 1 0-1.25h7.824l-1.6-1.6a.625.625 0 0 1 0-.883Z"/></svg>`,
};
export const iconBell24: {
  name: 'bell-24';
  data: string;
} = {
  name: 'bell-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12 3.75A1.25 1.25 0 0 0 10.75 5a.75.75 0 0 1-.43.678 6.25 6.25 0 0 0-3.57 5.34V14a1 1 0 0 1-.005.09 4.75 4.75 0 0 1-.83 2.16h12.17a4.75 4.75 0 0 1-.829-2.16 1 1 0 0 1-.006-.09v-2.982a6.25 6.25 0 0 0-3.57-5.34.75.75 0 0 1-.43-.678A1.25 1.25 0 0 0 12 3.75m2.25 14h-4.5V18a2.25 2.25 0 0 0 4.5 0zm-6 0V18a3.75 3.75 0 1 0 7.5 0v-.25H20a.75.75 0 0 0 .37-1.403 3.25 3.25 0 0 1-1.62-2.395v-2.987a7.75 7.75 0 0 0-4.043-6.447 2.751 2.751 0 0 0-5.415 0A7.75 7.75 0 0 0 5.25 11v2.952a3.25 3.25 0 0 1-1.62 2.395A.75.75 0 0 0 4 17.75z"/></svg>`,
};
export const iconBook24: {
  name: 'book-24';
  data: string;
} = {
  name: 'book-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M6.194 4.194a1.5 1.5 0 0 1 1.07-.444h2.42v6.496a.75.75 0 0 0 1.28.53l2.188-2.187 2.186 2.187a.75.75 0 0 0 1.28-.53V3.75h2.124v12.086H7.264c-.536 0-1.058.143-1.514.408V5.264c0-.401.16-.786.444-1.07m8.925-.444v4.685l-1.437-1.437a.75.75 0 0 0-1.06 0l-1.438 1.437V3.75zm.75-1.5h3.623a.75.75 0 0 1 .75.75v18.114a.75.75 0 0 1-.75.75H7.264A3.014 3.014 0 0 1 4.25 18.85V5.264A3.014 3.014 0 0 1 7.264 2.25zM7.264 17.336h11.478v3.029H7.264a1.514 1.514 0 1 1 0-3.03Z"/></svg>`,
};
export const iconBookmark16: {
  name: 'bookmark-16';
  data: string;
} = {
  name: 'bookmark-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M6.664 2.625a2.04 2.04 0 0 0-2.042 2.042v8.165l3.029-2.019c.21-.14.483-.14.693 0l3.028 2.02V4.666a2.04 2.04 0 0 0-2.041-2.042zm-2.327-.286a3.3 3.3 0 0 1 2.327-.964h2.667a3.29 3.29 0 0 1 3.291 3.292V14a.625.625 0 0 1-.971.52l-3.654-2.435-3.653 2.435a.625.625 0 0 1-.972-.52V4.667c0-.873.347-1.71.965-2.328"/></svg>`,
};
export const iconBookmark24: {
  name: 'bookmark-24';
  data: string;
} = {
  name: 'bookmark-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M10 3.75A3.25 3.25 0 0 0 6.75 7v12.599l4.834-3.223a.75.75 0 0 1 .832 0l4.834 3.223V7A3.25 3.25 0 0 0 14 3.75zm-3.359-.109A4.75 4.75 0 0 1 10 2.25h4A4.75 4.75 0 0 1 18.75 7v14a.75.75 0 0 1-1.166.624L12 17.901l-5.584 3.723A.75.75 0 0 1 5.25 21V7c0-1.26.5-2.468 1.391-3.359"/></svg>`,
};
export const iconBookmarkFilled24: {
  name: 'bookmark-filled-24';
  data: string;
} = {
  name: 'bookmark-filled-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M14 2a5 5 0 0 1 5 5v14a1 1 0 0 1-1.555.832L12 18.202l-5.444 3.63a1 1 0 0 1-1.55-.72L5 21V7a5 5 0 0 1 5-5z"/></svg>`,
};
export const iconBookmarkOff16: {
  name: 'bookmark-off-16';
  data: string;
} = {
  name: 'bookmark-off-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16"><path fill-rule="evenodd" d="M6.795 2.625a2.03 2.03 0 0 0-1.168.368.625.625 0 1 1-.718-1.024 3.3 3.3 0 0 1 1.888-.594h2.666a3.29 3.29 0 0 1 3.291 3.292v4.666a.625.625 0 1 1-1.25 0V4.667a2.04 2.04 0 0 0-2.041-2.042zM1.687 1.558a.625.625 0 0 1 .884 0l10 10 2 2a.625.625 0 1 1-.883.884l-.934-.933V14a.625.625 0 0 1-.971.52l-3.654-2.435-3.653 2.435a.625.625 0 0 1-.972-.52V4.667q0-.196.023-.386l-1.84-1.839a.625.625 0 0 1 0-.884m3.067 3.95v7.324l3.029-2.019c.21-.14.483-.14.693 0l3.028 2.02v-.574l-6.75-6.75Z"/></svg>`,
};
export const iconBookmarkOff24: {
  name: 'bookmark-off-24';
  data: string;
} = {
  name: 'bookmark-off-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M9.999 3.75a3.23 3.23 0 0 0-1.86.585.75.75 0 0 1-.861-1.228A4.73 4.73 0 0 1 10 2.25h4A4.75 4.75 0 0 1 18.75 7v7a.75.75 0 0 1-1.5 0V7A3.25 3.25 0 0 0 14 3.75zm-7.53-1.28a.75.75 0 0 1 1.061 0l18 18a.75.75 0 1 1-1.06 1.06l-1.72-1.72V21a.75.75 0 0 1-1.166.624L12 17.901l-5.584 3.723A.75.75 0 0 1 5.25 21V7q0-.329.043-.646L2.47 3.53a.75.75 0 0 1 0-1.06ZM6.75 7.81V19.6l4.834-3.223a.75.75 0 0 1 .832 0L17.25 19.6v-1.29z"/></svg>`,
};
export const iconBox24: {
  name: 'box-24';
  data: string;
} = {
  name: 'box-24',
  data: `<svg width="25" height="24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M11.028 1.614a2.77 2.77 0 0 1 2.744 0l7 4.007v.001c.35.199.65.472.88.799a.76.76 0 0 1 .198.328c.196.383.3.808.3 1.24v8.019c0 .98-.527 1.881-1.377 2.369l-7 4.008a2.77 2.77 0 0 1-2.745 0l-7-4.008A2.73 2.73 0 0 1 2.65 16.01V7.991c0-.44.106-.863.3-1.24a.75.75 0 0 1 .2-.332c.227-.321.524-.594.877-.797zM4.15 8.104v7.905c0 .438.235.845.622 1.066l6.878 3.938v-8.58zm9 4.329v8.58l6.877-3.938a1.23 1.23 0 0 0 .623-1.067V8.103zm6.71-5.605-6.832-3.912a1.27 1.27 0 0 0-1.256 0L4.941 6.828l7.459 4.306z"/></svg>`,
};
export const iconCalculate16: {
  name: 'calculate-16';
  data: string;
} = {
  name: 'calculate-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M7.397 3.162a.625.625 0 0 1 .601-.454h4.667a.625.625 0 1 1 0 1.25H8.47l-2.538 8.88a.625.625 0 0 1-1.16.108L2.945 9.292h-.947a.625.625 0 1 1 0-1.25h1.334c.236 0 .453.133.559.345l1.281 2.563zM8.89 8.225a.625.625 0 0 1 .883 0l1.559 1.558 1.558-1.558a.625.625 0 1 1 .883.884l-1.558 1.558 1.558 1.558a.625.625 0 0 1-.883.883l-1.56-1.558-1.558 1.558a.625.625 0 1 1-.883-.883l1.558-1.558L8.89 9.109a.625.625 0 0 1 0-.884"/></svg>`,
};
export const iconCalculate24: {
  name: 'calculate-24';
  data: string;
} = {
  name: 'calculate-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M11.278 4.794A.75.75 0 0 1 12 4.25h7a.75.75 0 0 1 0 1.5h-6.434L8.721 19.206a.75.75 0 0 1-1.392.13L4.536 13.75H3a.75.75 0 0 1 0-1.5h2a.75.75 0 0 1 .67.415l2.138 4.275zm2.191 7.676a.75.75 0 0 1 1.06 0L17 14.94l2.47-2.47a.75.75 0 1 1 1.06 1.06L18.06 16l2.47 2.47a.75.75 0 1 1-1.06 1.06L17 17.06l-2.47 2.47a.75.75 0 1 1-1.06-1.06L15.938 16l-2.47-2.47a.75.75 0 0 1 0-1.06Z"/></svg>`,
};
export const iconCall16: {
  name: 'call-16';
  data: string;
} = {
  name: 'call-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.333 2.625a.71.71 0 0 0-.708.692 10.04 10.04 0 0 0 9.39 9.391.71.71 0 0 0 .693-.708V9.756l-2.446-.978-.726 1.21a.625.625 0 0 1-.813.24A7.96 7.96 0 0 1 5.106 6.61a.625.625 0 0 1 .239-.813l1.21-.726-.979-2.446zm-1.385-.676a1.96 1.96 0 0 1 1.385-.574H6c.255 0 .485.156.58.393L7.913 5.1a.625.625 0 0 1-.258.768l-1.152.691a6.7 6.7 0 0 0 2.27 2.27l.69-1.152a.625.625 0 0 1 .769-.258l3.333 1.333a.625.625 0 0 1 .393.58V12a1.96 1.96 0 0 1-1.996 1.957A11.29 11.29 0 0 1 1.375 3.333c0-.519.206-1.017.573-1.384"/></svg>`,
};
export const iconChangelog24: {
  name: 'changelog-24';
  data: string;
} = {
  name: 'changelog-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M18.73 9.177a7.28 7.28 0 0 1 .054 5.573.75.75 0 0 0 1.392.56A8.782 8.782 0 0 0 4.78 7.075V4.03a.75.75 0 0 0-1.5 0v5c0 .414.336.75.75.75h5a.75.75 0 0 0 0-1.5H5.79a7.281 7.281 0 0 1 12.94.897M17.62 18.4a.75.75 0 0 0-.75-.75h-.01a.75.75 0 1 0 0 1.5h.01a.75.75 0 0 0 .75-.75m-3.84 1.57a.75.75 0 0 0-.75-.75h-.01a.75.75 0 1 0 0 1.5h.01a.75.75 0 0 0 .75-.75m-4.1-.57a.75.75 0 0 0-.75-.75h-.01a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 .75-.75m-3.27-2.53a.75.75 0 0 0-.75-.75h-.01a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 .75-.75m-1.57-3.84a.75.75 0 0 0-.75-.75h-.01a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 .75-.75"/></svg>`,
};
export const iconCheck16: {
  name: 'check-16';
  data: string;
} = {
  name: 'check-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M13.774 4.225a.625.625 0 0 1 0 .883l-6.666 6.667a.625.625 0 0 1-.884 0L2.89 8.442a.625.625 0 1 1 .883-.884l2.892 2.891 6.225-6.224a.625.625 0 0 1 .883 0Z"/></svg>`,
};
export const iconChevronDown16: {
  name: 'chevron-down-16';
  data: string;
} = {
  name: 'chevron-down-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M8 10.775a.63.63 0 0 1-.458-.2l-4-4.3a.625.625 0 0 1 .915-.85l3.542 3.807 3.543-3.808a.625.625 0 0 1 .915.852l-4 4.3a.63.63 0 0 1-.458.199Z"/></svg>`,
};
export const iconChevronDown24: {
  name: 'chevron-down-24';
  data: string;
} = {
  name: 'chevron-down-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12.53 15.53a.75.75 0 0 1-1.06 0l-6-6a.75.75 0 0 1 1.06-1.06L12 13.94l5.47-5.47a.75.75 0 1 1 1.06 1.06z"/></svg>`,
};
export const iconChevronLeft16: {
  name: 'chevron-left-16';
  data: string;
} = {
  name: 'chevron-left-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M5.224 8c0-.174.072-.34.199-.458l4.3-4a.625.625 0 1 1 .851.916L6.766 8l3.808 3.542a.625.625 0 1 1-.851.916l-4.3-4a.63.63 0 0 1-.2-.458Z"/></svg>`,
};
export const iconChevronLeft24: {
  name: 'chevron-left-24';
  data: string;
} = {
  name: 'chevron-left-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M8.47 12.53a.75.75 0 0 1 0-1.06l6-6a.75.75 0 1 1 1.06 1.06L10.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06z"/></svg>`,
};
export const iconChevronRight16: {
  name: 'chevron-right-16';
  data: string;
} = {
  name: 'chevron-right-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M10.455 7.574a.625.625 0 0 1 0 .852l-4 4.3a.625.625 0 1 1-.915-.852L9.144 8 5.54 4.126a.625.625 0 1 1 .915-.851l4 4.3Z"/></svg>`,
};
export const iconChevronRight24: {
  name: 'chevron-right-24';
  data: string;
} = {
  name: 'chevron-right-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M15.53 11.47a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 0 1-1.06-1.06L13.94 12 8.47 6.53a.75.75 0 0 1 1.06-1.06z"/></svg>`,
};
export const iconChevronUp16: {
  name: 'chevron-up-16';
  data: string;
} = {
  name: 'chevron-up-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M7.999 5.225c.173 0 .34.073.458.2l4 4.3a.625.625 0 0 1-.916.85L8 6.768l-3.542 3.808a.625.625 0 1 1-.916-.852l4-4.3A.63.63 0 0 1 8 5.226Z"/></svg>`,
};
export const iconChevronUp24: {
  name: 'chevron-up-24';
  data: string;
} = {
  name: 'chevron-up-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M11.47 8.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 1 1-1.06 1.06L12 10.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06z"/></svg>`,
};
export const iconChimney24: {
  name: 'chimney-24';
  data: string;
} = {
  name: 'chimney-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M11.25 5.25A2.75 2.75 0 0 1 14 2.5.75.75 0 0 0 14 1a4.25 4.25 0 0 0-4.25 4.25.75.75 0 0 0 1.5 0"/><path d="M17.25 2.25a.75.75 0 0 0-1.5 0A.75.75 0 0 1 15 3h-1a2.25 2.25 0 0 0-2.25 2.25.75.75 0 0 0 1.5 0A.75.75 0 0 1 14 4.5h1a2.25 2.25 0 0 0 2.25-2.25M9.5 6.75a.75.75 0 0 0 0 1.5h4a.75.75 0 0 0 0-1.5zm-3 14.5a.75.75 0 0 0 0 1.5h10a.75.75 0 0 0 0-1.5z"/><path fill-rule="evenodd" d="M8.75 9.75A.75.75 0 0 1 9.5 9h4a.75.75 0 0 1 .75.75v1.938c0 2.636.323 5.263.963 7.821l.015.06a.75.75 0 0 1-.728.931h-6a.75.75 0 0 1-.728-.932l.015-.059a32.3 32.3 0 0 0 .963-7.822zm1.5.75v1.188c0 2.46-.269 4.912-.802 7.312h4.104a33.8 33.8 0 0 1-.802-7.313V10.5z"/></svg>`,
};
export const iconCircleAdd16: {
  name: 'circle-add-16';
  data: string;
} = {
  name: 'circle-add-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.315 3.315a6.625 6.625 0 1 1 9.37 9.37 6.625 6.625 0 0 1-9.37-9.37M8 2.625a5.375 5.375 0 1 0 0 10.75 5.375 5.375 0 0 0 0-10.75m0 2.75c.345 0 .625.28.625.625v1.375H10a.625.625 0 1 1 0 1.25H8.625V10a.625.625 0 1 1-1.25 0V8.625H6a.625.625 0 1 1 0-1.25h1.375V6c0-.345.28-.625.625-.625"/></svg>`,
};
export const iconCircleAdd24: {
  name: 'circle-add-24';
  data: string;
} = {
  name: 'circle-add-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5.106 5.106a9.75 9.75 0 1 1 13.788 13.788A9.75 9.75 0 0 1 5.106 5.106M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m0 4.5a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V15a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V9a.75.75 0 0 1 .75-.75"/></svg>`,
};
export const iconCircleAdded16: {
  name: 'circle-added-16';
  data: string;
} = {
  name: 'circle-added-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M8.005 14.63a6.625 6.625 0 1 0 0-13.25 6.625 6.625 0 0 0 0 13.25M8.625 5a.625.625 0 1 0-1.25 0v2.375H5a.625.625 0 1 0 0 1.25h2.375V11a.625.625 0 1 0 1.25 0V8.625H11a.625.625 0 1 0 0-1.25H8.625z"/></svg>`,
};
export const iconCircleChevronUp24: {
  name: 'circle-chevron-up-24';
  data: string;
} = {
  name: 'circle-chevron-up-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M8.269 2.992a9.75 9.75 0 1 1 7.462 18.016A9.75 9.75 0 0 1 8.27 2.992ZM12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m0 7.31-2.47 2.47a.75.75 0 0 1-1.06-1.06l3-3a.75.75 0 0 1 1.06 0l3 3a.75.75 0 1 1-1.06 1.06z"/></svg>`,
};
export const iconCircleChevronUpFilled24: {
  name: 'circle-chevron-up-filled-24';
  data: string;
} = {
  name: 'circle-chevron-up-filled-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12 21.75c5.385 0 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25 2.25 6.615 2.25 12s4.365 9.75 9.75 9.75m-2.47-8.22L12 11.06l2.47 2.47a.75.75 0 1 0 1.06-1.06l-3-3a.75.75 0 0 0-1.06 0l-3 3a.75.75 0 1 0 1.06 1.06"/></svg>`,
};
export const iconCircleClose16: {
  name: 'circle-close-16';
  data: string;
} = {
  name: 'circle-close-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M5.598 2.005a6.638 6.638 0 1 1 5.08 12.267 6.638 6.638 0 0 1-5.08-12.267m2.54.516a5.617 5.617 0 1 0 0 11.235 5.617 5.617 0 0 0 0-11.235"/><path fill-rule="evenodd" d="M6.313 6.313a.5.5 0 0 1 .707 0l.98.98.98-.98a.5.5 0 1 1 .707.707l-.98.98.98.98a.5.5 0 1 1-.707.707L8 8.707l-.98.98a.5.5 0 1 1-.707-.707l.98-.98-.98-.98a.5.5 0 0 1 0-.707"/></svg>`,
};
export const iconCircleClose24: {
  name: 'circle-close-24';
  data: string;
} = {
  name: 'circle-close-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M8.269 2.992a9.75 9.75 0 1 1 7.462 18.016A9.75 9.75 0 0 1 8.27 2.992ZM12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5"/><path fill-rule="evenodd" d="M9.47 9.47a.75.75 0 0 1 1.06 0L12 10.94l1.47-1.47a.75.75 0 1 1 1.06 1.06L13.06 12l1.47 1.47a.75.75 0 1 1-1.06 1.06L12 13.06l-1.47 1.47a.75.75 0 1 1-1.06-1.06L10.94 12l-1.47-1.47a.75.75 0 0 1 0-1.06"/></svg>`,
};
export const iconCircleRemove16: {
  name: 'circle-remove-16';
  data: string;
} = {
  name: 'circle-remove-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3.19 2.94a6.626 6.626 0 1 1 9.37 9.37 6.626 6.626 0 0 1-9.37-9.37m4.684-.69a5.375 5.375 0 1 0 0 10.75 5.375 5.375 0 0 0 0-10.75m0 4.75h3a.625.625 0 0 1 0 1.25h-6a.625.625 0 0 1 0-1.25z"/></svg>`,
};
export const iconCircleRemoved16: {
  name: 'circle-removed-16';
  data: string;
} = {
  name: 'circle-removed-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M8.005 14.63a6.625 6.625 0 1 0 0-13.25 6.625 6.625 0 0 0 0 13.25M11 7.375H5a.625.625 0 0 0 0 1.25h6a.625.625 0 1 0 0-1.25"/></svg>`,
};
export const iconClose16: {
  name: 'close-16';
  data: string;
} = {
  name: 'close-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.557 3.558a.625.625 0 0 1 .884 0L8 7.116l3.558-3.558a.625.625 0 0 1 .884.884L8.883 8l3.558 3.558a.625.625 0 1 1-.884.884L8 8.884l-3.558 3.558a.625.625 0 1 1-.884-.884L7.115 8 3.557 4.442a.625.625 0 0 1 0-.884"/></svg>`,
};
export const iconClose24: {
  name: 'close-24';
  data: string;
} = {
  name: 'close-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M4.47 4.47a.75.75 0 0 1 1.06 0L12 10.94l6.47-6.47a.75.75 0 1 1 1.06 1.06L13.06 12l6.47 6.47a.75.75 0 1 1-1.06 1.06L12 13.06l-6.47 6.47a.75.75 0 0 1-1.06-1.06L10.94 12 4.47 5.53a.75.75 0 0 1 0-1.06"/></svg>`,
};
export const iconComment16: {
  name: 'comment-16';
  data: string;
} = {
  name: 'comment-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.997 2.625A1.375 1.375 0 0 0 2.622 4v5.333a1.375 1.375 0 0 0 1.375 1.375H5.33c.346 0 .625.28.625.625v.896l2.387-1.432a.6.6 0 0 1 .322-.089h3.333a1.375 1.375 0 0 0 1.375-1.375V4a1.375 1.375 0 0 0-1.375-1.375zm-1.856-.481a2.63 2.63 0 0 1 1.856-.769h8A2.625 2.625 0 0 1 14.622 4v5.333a2.625 2.625 0 0 1-2.625 2.625h-3.16L5.652 13.87a.625.625 0 0 1-.947-.536v-1.375h-.708a2.625 2.625 0 0 1-2.625-2.625V4c0-.696.277-1.364.769-1.856m2.564 3.19c0-.346.28-.626.625-.626h5.334a.625.625 0 1 1 0 1.25H5.33a.625.625 0 0 1-.625-.625Zm0 2.666c0-.345.28-.625.625-.625h4a.625.625 0 1 1 0 1.25h-4A.625.625 0 0 1 4.705 8"/></svg>`,
};
export const iconContact24: {
  name: 'contact-24';
  data: string;
} = {
  name: 'contact-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24"><path fill-rule="evenodd" d="M4.814 4.116a1.25 1.25 0 0 1 .884-.366h14A1.25 1.25 0 0 1 20.948 5v14a1.25 1.25 0 0 1-1.25 1.25h-.25V20a4.75 4.75 0 0 0-4.75-4.75h-4A4.75 4.75 0 0 0 5.948 20v.25h-.25A1.25 1.25 0 0 1 4.448 19V5c0-.332.132-.65.366-.884M7.448 20.25V20a3.25 3.25 0 0 1 3.25-3.25h4a3.25 3.25 0 0 1 3.25 3.25v.25zm11.25 1.5h1a2.75 2.75 0 0 0 2.75-2.75V5a2.75 2.75 0 0 0-2.75-2.75h-14A2.75 2.75 0 0 0 2.948 5v14a2.75 2.75 0 0 0 2.75 2.75zm-6-15.5a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5m-1.591 2.159a2.25 2.25 0 1 1 3.182 3.182 2.25 2.25 0 0 1-3.182-3.182"/></svg>`,
};
export const iconCriticalWarning16: {
  name: 'critical-warning-16';
  data: string;
} = {
  name: 'critical-warning-16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M7.58 2.07 3.09 4.72l-.017.009a.86.86 0 0 0-.448.75v4.856a.86.86 0 0 0 .481.771l4.482 2.835a.89.89 0 0 0 .824 0l4.482-2.835.033-.02a.86.86 0 0 0 .448-.75v-4.86a.84.84 0 0 0-.412-.752l-.008-.004L8.463 2.07a.93.93 0 0 0-.882 0M6.97.98a2.18 2.18 0 0 1 2.12.008l4.496 2.651c.675.387 1.043 1.1 1.039 1.842v4.854c0 .762-.414 1.463-1.078 1.836l-4.485 2.837-.033.02a2.14 2.14 0 0 1-2.091-.02l-4.485-2.837a2.11 2.11 0 0 1-1.078-1.835V5.478c0-.766.418-1.469 1.087-1.84L6.955.987zM8 4.707c.345 0 .625.28.625.625V8a.625.625 0 1 1-1.25 0V5.333c0-.345.28-.625.625-.625m-.625 5.959c0-.345.28-.625.625-.625h.007a.625.625 0 0 1 0 1.25H8a.625.625 0 0 1-.625-.625"/></svg>`,
};
export const iconDashboard24: {
  name: 'dashboard-24';
  data: string;
} = {
  name: 'dashboard-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M3.25 4A.75.75 0 0 1 4 3.25h6a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75zm1.5.75v6.5h4.5v-6.5zm8.5-.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75zm1.5.75v2.5h4.5v-2.5zM13.25 12a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75zm1.5.75v6.5h4.5v-6.5zM3.25 16a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-.75.75H4a.75.75 0 0 1-.75-.75zm1.5.75v2.5h4.5v-2.5z"/></svg>`,
};
export const iconDelete16: {
  name: 'delete-16';
  data: string;
} = {
  name: 'delete-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16"><path fill-rule="evenodd" d="M7.13 2.625a.04.04 0 0 0-.042.042v1.375h2.75V2.667a.04.04 0 0 0-.042-.042zm3.958 1.417V2.667a1.29 1.29 0 0 0-1.292-1.292H7.13a1.29 1.29 0 0 0-1.292 1.292v1.375H3.13a.625.625 0 1 0 0 1.25h.091l.617 7.403a1.96 1.96 0 0 0 1.958 1.93h5.334a1.96 1.96 0 0 0 1.958-1.93l.617-7.403h.091a.625.625 0 1 0 0-1.25zm-6.612 1.25.61 7.323.002.052a.71.71 0 0 0 .708.708h5.334a.71.71 0 0 0 .708-.708q0-.027.002-.052l.61-7.323zM7.13 6.708c.345 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0v-4c0-.345.28-.625.625-.625m2.666 0c.346 0 .625.28.625.625v4a.625.625 0 1 1-1.25 0v-4c0-.345.28-.625.625-.625"/></svg>`,
};
export const iconDelete24: {
  name: 'delete-24';
  data: string;
} = {
  name: 'delete-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M10.5 3.75a.25.25 0 0 0-.25.25v2.25h4.5V4a.25.25 0 0 0-.25-.25zm5.75 2.5V4a1.75 1.75 0 0 0-1.75-1.75h-4A1.75 1.75 0 0 0 8.75 4v2.25H4.5a.75.75 0 0 0 0 1.5h.31l.94 11.284A2.75 2.75 0 0 0 8.5 21.75h8a2.75 2.75 0 0 0 2.75-2.716l.94-11.284h.31a.75.75 0 0 0 0-1.5zm-9.935 1.5.932 11.188q.003.03.003.062a1.25 1.25 0 0 0 1.25 1.25h8A1.25 1.25 0 0 0 17.75 19q0-.031.003-.062l.932-11.188zm4.185 2.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75m4 0a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75"/></svg>`,
};
export const iconDocumentation24: {
  name: 'documentation-24';
  data: string;
} = {
  name: 'documentation-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M7 3.75A1.25 1.25 0 0 0 5.75 5v14A1.25 1.25 0 0 0 7 20.25h10A1.25 1.25 0 0 0 18.25 19V8.75H15A1.75 1.75 0 0 1 13.25 7V3.75zm7.75 1.06 2.44 2.44H15a.25.25 0 0 1-.25-.25zM5.055 3.056A2.75 2.75 0 0 1 7 2.25h7a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v11A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5c0-.73.29-1.429.805-1.945ZM11.25 11a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75m-1 3a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .75.75v3.25H13a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75v-3.25H11a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconDrag24: {
  name: 'drag-24';
  data: string;
} = {
  name: 'drag-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M9 20q-.825 0-1.412-.587A1.93 1.93 0 0 1 7 18q0-.825.588-1.413A1.93 1.93 0 0 1 9 16q.825 0 1.413.587Q11 17.175 11 18c0 .825-.196 1.021-.587 1.413A1.93 1.93 0 0 1 9 20m6 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 13 18q0-.825.588-1.413A1.93 1.93 0 0 1 15 16q.825 0 1.413.587Q17 17.175 17 18c0 .825-.196 1.021-.587 1.413A1.93 1.93 0 0 1 15 20m-6-6q-.825 0-1.412-.588A1.92 1.92 0 0 1 7 12q0-.825.588-1.413A1.93 1.93 0 0 1 9 10q.825 0 1.413.587Q11 11.175 11 12c0 .825-.196 1.02-.587 1.412A1.93 1.93 0 0 1 9 14m6 0q-.825 0-1.412-.588A1.92 1.92 0 0 1 13 12q0-.825.588-1.413A1.93 1.93 0 0 1 15 10q.825 0 1.413.587Q17 11.175 17 12c0 .825-.196 1.02-.587 1.412A1.93 1.93 0 0 1 15 14M9 8q-.825 0-1.412-.588A1.92 1.92 0 0 1 7 6q0-.824.588-1.412A1.92 1.92 0 0 1 9 4q.825 0 1.413.588Q11 5.175 11 6q0 .824-.587 1.412A1.93 1.93 0 0 1 9 8m6 0q-.825 0-1.412-.588A1.92 1.92 0 0 1 13 6q0-.824.588-1.412A1.92 1.92 0 0 1 15 4q.825 0 1.413.588Q17 5.175 17 6q0 .824-.587 1.412A1.93 1.93 0 0 1 15 8"/></svg>`,
};
export const iconDrop24: {
  name: 'drop-24';
  data: string;
} = {
  name: 'drop-24',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.001 1.25a.75.75 0 0 1 .62.327l6.062 8.877.025.038c1.89 3.165 1.149 7.179-1.738 9.514-2.876 2.328-7.063 2.328-9.94 0-2.887-2.335-3.629-6.35-1.739-9.514l.025-.038 6.066-8.877a.75.75 0 0 1 .62-.327M6.568 11.28c-1.486 2.51-.906 5.69 1.406 7.56 2.327 1.882 5.726 1.882 8.052 0 2.311-1.87 2.892-5.05 1.406-7.56L12 3.33z"/></svg>`,
};
export const iconDuplicate16: {
  name: 'duplicate-16';
  data: string;
} = {
  name: 'duplicate-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="16"><path d="M10.332 7.336c.345 0 .625.28.625.625v.985h.985a.625.625 0 1 1 0 1.25h-.985v.985a.625.625 0 1 1-1.25 0v-.985h-.985a.625.625 0 0 1 0-1.25h.985v-.985c0-.345.28-.625.625-.625"/><path fill-rule="evenodd" d="M4.43 1.49a2.056 2.056 0 0 0-2.056 2.055V9.27a2.056 2.056 0 0 0 2.056 2.056h.805v.807a2.056 2.056 0 0 0 2.056 2.056h5.724a2.056 2.056 0 0 0 2.056-2.056V6.408a2.056 2.056 0 0 0-2.056-2.056h-.806v-.807a2.056 2.056 0 0 0-2.056-2.055zm6.53 2.862v-.807a.806.806 0 0 0-.807-.805H4.43a.806.806 0 0 0-.806.805V9.27a.806.806 0 0 0 .806.806h.805V6.408a2.056 2.056 0 0 1 2.056-2.056h3.668Zm-4.475 6.354V6.408a.806.806 0 0 1 .806-.806h5.724a.806.806 0 0 1 .806.806v5.724a.806.806 0 0 1-.806.806H7.291a.806.806 0 0 1-.806-.806z"/></svg>`,
};
export const iconDuplicate24: {
  name: 'duplicate-24';
  data: string;
} = {
  name: 'duplicate-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="26" height="24"><path fill-rule="evenodd" d="M6.646 2.422A2.896 2.896 0 0 0 3.75 5.318v8.586a2.897 2.897 0 0 0 2.896 2.897h1.397v1.396a2.896 2.896 0 0 0 2.896 2.897h8.586a2.896 2.896 0 0 0 2.897-2.897V9.611a2.896 2.896 0 0 0-2.897-2.896H18.13V5.318a2.896 2.896 0 0 0-2.897-2.896zm9.983 4.293V5.318a1.396 1.396 0 0 0-1.397-1.396H6.646A1.396 1.396 0 0 0 5.25 5.318v8.586a1.397 1.397 0 0 0 1.396 1.397h1.397V9.61a2.896 2.896 0 0 1 2.896-2.896h5.69ZM9.952 8.624c.262-.262.617-.41.987-.41h8.586a1.397 1.397 0 0 1 1.397 1.397v8.586a1.396 1.396 0 0 1-1.397 1.397H10.94a1.396 1.396 0 0 1-1.396-1.397V9.611c0-.37.147-.725.409-.987Zm5.549 2.568a.75.75 0 0 1 .75.75v1.665h1.664a.75.75 0 0 1 0 1.5h-1.664v1.665a.75.75 0 0 1-1.5 0v-1.665h-1.665a.75.75 0 0 1 0-1.5h1.665v-1.665a.75.75 0 0 1 .75-.75"/></svg>`,
};
export const iconEdit16: {
  name: 'edit-16';
  data: string;
} = {
  name: 'edit-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15"><path fill-rule="evenodd" d="M10.373 2.009a2.51 2.51 0 0 1 2.736 4.095l-.667.666-6.333 6.334a.63.63 0 0 1-.442.183H3a.625.625 0 0 1-.625-.625V9.995c0-.166.066-.325.183-.442l7-7a2.5 2.5 0 0 1 .815-.544m-1.04 2.536-5.708 5.709v1.783h1.783l5.708-5.709zm2.667.9-1.783-1.783.225-.225a1.262 1.262 0 0 1 1.783 1.783L12 5.444Z"/></svg>`,
};
export const iconEmissionLimit24: {
  name: 'emission-limit-24';
  data: string;
} = {
  name: 'emission-limit-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5.25 3.75a1.5 1.5 0 0 0-1.5 1.5V7.5a.75.75 0 0 1-1.5 0V5.25a3 3 0 0 1 3-3H7.5a.75.75 0 0 1 0 1.5zM3 15.75a.75.75 0 0 1 .75.75v2.25a1.5 1.5 0 0 0 1.5 1.5H7.5a.75.75 0 0 1 0 1.5H5.25a3 3 0 0 1-3-3V16.5a.75.75 0 0 1 .75-.75m13.5-13.5a.75.75 0 0 0 0 1.5h2.25a1.5 1.5 0 0 1 1.5 1.5V7.5a.75.75 0 0 0 1.5 0V5.25a3 3 0 0 0-3-3zm4.5 13.5a.75.75 0 0 1 .75.75v2.25a3 3 0 0 1-3 3H16.5a.75.75 0 0 1 0-1.5h2.25a1.5 1.5 0 0 0 1.5-1.5V16.5a.75.75 0 0 1 .75-.75m-9-4.072 3.085-1.928L12 7.822 8.915 9.75zm.398-5.377 4.486 2.805a.75.75 0 0 1 .366.654v5.053a.75.75 0 0 1-.352.635l-4.486 2.804a.75.75 0 0 1-.795.018l-.017-.01-4.497-2.812a.75.75 0 0 1-.353-.636V9.75a.75.75 0 0 1 .364-.643l4.488-2.805a.75.75 0 0 1 .796 0ZM8.25 11.104v3.294l3 1.875v-3.294zm4.5 5.169v-3.294l3-1.875v3.294z"/></svg>`,
};
export const iconEmptyDefault32: {
  name: 'empty-default-32';
  data: string;
} = {
  name: 'empty-default-32',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 32 32"><path d="M26.237 15.496a10.251 10.251 0 0 0-14.16-8.966c-1.012.42-1.947 1-2.773 1.713l14.452 14.452a10.244 10.244 0 0 0 1.714-2.772c.515-1.244.78-2.577.78-3.923l-.013-.504ZM5.763 16.504a10.252 10.252 0 0 0 6.314 8.966c1.244.515 2.577.78 3.923.78l.504-.013a10.251 10.251 0 0 0 3.419-.767c1.012-.42 1.946-1 2.772-1.714L8.243 9.304a10.25 10.25 0 0 0-1.713 2.773A10.252 10.252 0 0 0 5.75 16l.013.504Zm21.972.074a11.751 11.751 0 0 1-11.157 11.157L16 27.75A11.75 11.75 0 0 1 4.265 16.578L4.25 16a11.75 11.75 0 0 1 23.5 0l-.015.578Z"/></svg>`,
};
export const iconEmptyState32: {
  name: 'empty-state-32';
  data: string;
} = {
  name: 'empty-state-32',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32"><path fill-rule="evenodd" d="M3.47 3.47a.75.75 0 0 1 1.06 0l11.997 11.996.007.007 7.602 7.602a.8.8 0 0 1 .151.151l4.243 4.244a.75.75 0 1 1-1.06 1.06l-3.918-3.918-7.184 4.042a.75.75 0 0 1-.736 0l-10.666-6A.75.75 0 0 1 4.583 22V10c0-.27.146-.52.383-.654L7.09 8.151l-3.62-3.62a.75.75 0 0 1 0-1.061m4.722 5.782L6.863 10l4.746 2.67zm7.058 7.187-9.167-5.157v10.28l9.167 5.156v-10.28Zm1.5 10.279 5.7-3.207-5.7-5.7zM15.632 3.346a.75.75 0 0 1 .736 0l10.666 6a.75.75 0 0 1 .383.654v11.333a.75.75 0 0 1-1.5 0v-10.05l-6.135 3.45a.75.75 0 0 1-.735-1.308L25.137 10 16 4.86l-3.89 2.19a.75.75 0 0 1-.736-1.308z"/></svg>`,
};
export const iconEqualLower24: {
  name: 'equal-lower-24';
  data: string;
} = {
  name: 'equal-lower-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M19.721 5.794a.75.75 0 0 1-.515.927L7.73 10l11.476 3.279a.75.75 0 1 1-.412 1.442l-14-4a.75.75 0 0 1 0-1.442l14-4a.75.75 0 0 1 .927.515m-15.442 8a.75.75 0 0 1 .927-.515l14 4a.75.75 0 1 1-.412 1.442l-14-4a.75.75 0 0 1-.515-.927"/></svg>`,
};
export const iconError16: {
  name: 'error-16';
  data: string;
} = {
  name: 'error-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.315 3.315a6.625 6.625 0 1 1 9.369 9.37 6.625 6.625 0 0 1-9.37-9.37Zm4.684-.69a5.375 5.375 0 1 0 0 10.75 5.375 5.375 0 0 0 0-10.75m0 2.083c.345 0 .625.28.625.625V8a.625.625 0 1 1-1.25 0V5.333c0-.345.28-.625.625-.625m-.625 5.959c0-.345.28-.625.625-.625h.007a.625.625 0 1 1 0 1.25h-.007a.625.625 0 0 1-.625-.625"/></svg>`,
};
export const iconError24: {
  name: 'error-24';
  data: string;
} = {
  name: 'error-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5.106 5.106a9.75 9.75 0 1 1 13.788 13.788A9.75 9.75 0 0 1 5.106 5.106M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m0 3.5a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75M11.25 16a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconErrorFilled16: {
  name: 'error-filled-16';
  data: string;
} = {
  name: 'error-filled-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 4.5a.68.68 0 0 0-.5.202.68.68 0 0 0-.2.498v2.817a.65.65 0 0 0 .2.49.7.7 0 0 0 .5.193.68.68 0 0 0 .498-.2A.68.68 0 0 0 8.7 8V5.183a.65.65 0 0 0-.202-.49A.7.7 0 0 0 8 4.5m0 5.6a.68.68 0 0 0-.5.202q-.2.2-.2.498a.68.68 0 0 0 .2.5q.202.2.5.2a.68.68 0 0 0 .498-.2.68.68 0 0 0 .202-.5.68.68 0 0 0-.202-.498A.68.68 0 0 0 8 10.1M8 1a6.8 6.8 0 0 1 2.73.552 7.1 7.1 0 0 1 2.222 1.495 7.1 7.1 0 0 1 1.496 2.223Q15 6.548 15 8c0 1.452-.184 1.878-.552 2.73a7.1 7.1 0 0 1-1.496 2.223 7.1 7.1 0 0 1-2.222 1.496A6.8 6.8 0 0 1 8 15a6.8 6.8 0 0 1-2.73-.55 7.1 7.1 0 0 1-2.223-1.497 7.1 7.1 0 0 1-1.496-2.223A6.8 6.8 0 0 1 1 8q0-1.452.551-2.73a7.1 7.1 0 0 1 1.496-2.222A7.1 7.1 0 0 1 5.27 1.551 6.8 6.8 0 0 1 8 1"/></svg>`,
};
export const iconErrorFilled24: {
  name: 'error-filled-24';
  data: string;
} = {
  name: 'error-filled-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 7a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 8v4.025q0 .425.287.7.288.275.713.275c.425 0 .52-.096.712-.287A.97.97 0 0 0 13 12V7.975a.93.93 0 0 0-.288-.7A1 1 0 0 0 12 7m0 8a.97.97 0 0 0-.713.288A.97.97 0 0 0 11 16a.97.97 0 0 0 .287.713A.97.97 0 0 0 12 17a.97.97 0 0 0 .712-.287A.97.97 0 0 0 13 16a.97.97 0 0 0-.288-.712A.97.97 0 0 0 12 15m0-13a9.7 9.7 0 0 1 3.9.788 10.1 10.1 0 0 1 3.175 2.137q1.35 1.35 2.137 3.175A9.7 9.7 0 0 1 22 12a9.7 9.7 0 0 1-.788 3.9 10.1 10.1 0 0 1-2.137 3.175q-1.35 1.35-3.175 2.138A9.7 9.7 0 0 1 12 22a9.7 9.7 0 0 1-3.9-.787 10.1 10.1 0 0 1-3.175-2.138q-1.35-1.35-2.137-3.175A9.7 9.7 0 0 1 2 12a9.7 9.7 0 0 1 .788-3.9 10.1 10.1 0 0 1 2.137-3.175q1.35-1.35 3.175-2.137A9.7 9.7 0 0 1 12 2"/></svg>`,
};
export const iconExport16: {
  name: 'export-16';
  data: string;
} = {
  name: 'export-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.333 2.625a.71.71 0 0 0-.708.708v2.709h3.417V2.625zm0-1.25a1.96 1.96 0 0 0-1.958 1.958v9.334a1.96 1.96 0 0 0 1.958 1.958h5a.625.625 0 1 0 0-1.25H7.292V7.292h6.083v1.041a.625.625 0 1 0 1.25 0v-5a1.96 1.96 0 0 0-1.958-1.958zm3.959 1.25v3.417h6.083V3.333a.71.71 0 0 0-.708-.708zm-1.25 4.667H2.625v5.375a.71.71 0 0 0 .708.708h2.709zm6.183 3.817a.625.625 0 1 1 .884-.884l2 2a.625.625 0 0 1 0 .884l-2 2a.625.625 0 1 1-.884-.884l.933-.933h-2.491a.625.625 0 0 1 0-1.25h2.49z"/></svg>`,
};
export const iconExport24: {
  name: 'export-24';
  data: string;
} = {
  name: 'export-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5.116 4.23A1.25 1.25 0 0 1 6 3.865h6.25v3.25A1.75 1.75 0 0 0 14 8.864h3.25v4.25a.75.75 0 0 0 1.5 0v-5a.75.75 0 0 0-.22-.53l-5-5a.75.75 0 0 0-.53-.22H6a2.75 2.75 0 0 0-2.75 2.75v14A2.75 2.75 0 0 0 6 21.864h4.5a.75.75 0 0 0 0-1.5H6a1.25 1.25 0 0 1-1.25-1.25v-14c0-.331.132-.649.366-.883ZM16.19 7.365l-2.44-2.44v2.19a.25.25 0 0 0 .25.25zm1.341 8.22a.75.75 0 1 0-1.06 1.06l1.72 1.72H13a.75.75 0 0 0 0 1.5h5.19l-1.72 1.72a.75.75 0 1 0 1.06 1.06l3-3a.75.75 0 0 0 0-1.06z"/></svg>`,
};
export const iconFan24: {
  name: 'fan-24';
  data: string;
} = {
  name: 'fan-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12 2.25c-1.465 0-2.61.366-3.357 1.095-.76.742-.988 1.74-.858 2.728.152 1.508.586 3.036 1.292 4.578a3.75 3.75 0 0 0-.757 1.628q-2.477.246-4.513 1.16c-.921.38-1.672 1.077-1.934 2.107-.258 1.012-.003 2.186.73 3.455.732 1.269 1.621 2.077 2.626 2.36 1.023.287 2.001-.015 2.792-.621 1.274-.918 2.415-2.108 3.426-3.56a.75.75 0 0 0 .134-.453 3.8 3.8 0 0 0 .838 0 .75.75 0 0 0 .134.452c1.01 1.452 2.151 2.642 3.426 3.56.79.604 1.767.905 2.79.619 1.005-.282 1.895-1.089 2.628-2.358.732-1.269.987-2.443.73-3.454-.262-1.03-1.012-1.726-1.933-2.108q-2.036-.914-4.514-1.16a3.75 3.75 0 0 0-.756-1.627c.705-1.542 1.139-3.07 1.291-4.578.13-.988-.098-1.986-.858-2.728-.748-.73-1.892-1.095-3.357-1.095m1.719 7.417c.552-1.29.883-2.541 1.005-3.756l.003-.025c.086-.638-.069-1.127-.418-1.467-.365-.357-1.066-.669-2.309-.669s-1.944.312-2.31.669c-.348.34-.503.83-.417 1.467l.003.025c.122 1.215.453 2.466 1.005 3.756a3.75 3.75 0 0 1 3.438 0m1.948 4.117a3.75 3.75 0 0 1-1.895 2.52l.013.019c.928 1.335 1.957 2.398 3.079 3.205l.02.015c.508.39 1.01.502 1.48.37.492-.138 1.112-.587 1.733-1.663.622-1.076.702-1.84.576-2.334-.12-.473-.467-.851-1.06-1.095l-.024-.01c-1.157-.522-2.462-.867-3.922-1.027m-5.438 2.521a3.75 3.75 0 0 1-1.896-2.52c-1.46.16-2.764.505-3.92 1.027l-.025.01c-.594.244-.941.622-1.062 1.094-.126.496-.046 1.259.576 2.335.621 1.076 1.242 1.527 1.733 1.665.47.132.971.021 1.48-.372l.02-.015c1.122-.807 2.151-1.87 3.08-3.206zm.18-4.896a2.25 2.25 0 1 1 3.182 3.183 2.25 2.25 0 0 1-3.182-3.183"/></svg>`,
};
export const iconFileinfo24: {
  name: 'fileinfo-24';
  data: string;
} = {
  name: 'fileinfo-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M7 3.75A1.25 1.25 0 0 0 5.75 5v14A1.25 1.25 0 0 0 7 20.25h10A1.25 1.25 0 0 0 18.25 19V8.75H15A1.75 1.75 0 0 1 13.25 7V3.75zm7.75 1.06 2.44 2.44H15a.25.25 0 0 1-.25-.25zM5.055 3.056A2.75 2.75 0 0 1 7 2.25h7a.75.75 0 0 1 .53.22l5 5c.141.14.22.331.22.53v11A2.75 2.75 0 0 1 17 21.75H7A2.75 2.75 0 0 1 4.25 19V5c0-.73.29-1.429.805-1.945ZM12 10.25a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5zm-1 3a.75.75 0 0 0 0 1.5h.25V18c0 .414.336.75.75.75h1a.75.75 0 0 0 0-1.5h-.25V14a.75.75 0 0 0-.75-.75z"/></svg>`,
};
export const iconFog24: {
  name: 'fog-24';
  data: string;
} = {
  name: 'fog-24',
  data: `<svg width="25" height="24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8.102 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m11 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-13-5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4.667 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6.333-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1.25-7a.75.75 0 0 1-.75.75h-7a.75.75 0 1 1 0-1.5h7a.75.75 0 0 1 .75.75M8.102 17.75a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z"/></svg>`,
};
export const iconFolder16: {
  name: 'folder-16';
  data: string;
} = {
  name: 'folder-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16"><path fill-rule="evenodd" d="M3.463 3.292A.71.71 0 0 0 2.754 4v7.333a.71.71 0 0 0 .32.592l1.641-4.378a1.29 1.29 0 0 1 1.21-.839h7.58V6a.71.71 0 0 0-.709-.708H8.13a.63.63 0 0 1-.442-.183L5.871 3.292zM14.754 6.87a1.29 1.29 0 0 1 .65 1.342l-.003.015-.664 3.474a1.96 1.96 0 0 1-1.923 1.59H3.463a1.96 1.96 0 0 1-1.959-1.958V4a1.96 1.96 0 0 1 1.959-1.958h2.666c.166 0 .325.066.442.183l1.817 1.817h4.408A1.96 1.96 0 0 1 14.754 6zm-10.39 5.172h8.45a.71.71 0 0 0 .695-.576l.662-3.462q0-.008-.002-.015a.04.04 0 0 0-.04-.03H5.925a.04.04 0 0 0-.039.026l-1.521 4.057Z"/></svg>`,
};
export const iconFolder24: {
  name: 'folder-24';
  data: string;
} = {
  name: 'folder-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5 4.75A1.25 1.25 0 0 0 3.75 6v11a1.25 1.25 0 0 0 .767 1.153l2.538-6.767a1.75 1.75 0 0 1 1.638-1.136H20.25V9A1.25 1.25 0 0 0 19 7.75h-7a.75.75 0 0 1-.53-.22L8.69 4.75zm16 7H8.693a.25.25 0 0 0-.234.162L6.082 18.25h12.944a1.25 1.25 0 0 0 1.227-1.016l.994-5.199a.25.25 0 0 0-.142-.262.3.3 0 0 0-.105-.023m.75-1.33a1.75 1.75 0 0 1 .976 1.867l-.003.018-.996 5.21a2.75 2.75 0 0 1-2.7 2.235H5A2.75 2.75 0 0 1 2.25 17V6A2.75 2.75 0 0 1 5 3.25h4a.75.75 0 0 1 .53.22l2.78 2.78H19A2.75 2.75 0 0 1 21.75 9z"/></svg>`,
};
export const iconFullscreenOff24: {
  name: 'fullscreen-off-24';
  data: string;
} = {
  name: 'fullscreen-off-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M2.47 2.47a.75.75 0 0 1 1.06 0l18 18a.75.75 0 1 1-1.06 1.06l-1.13-1.129a2.74 2.74 0 0 1-1.34.349h-2a.75.75 0 0 1 0-1.5h2q.09 0 .177-.012L4.762 5.823A1 1 0 0 0 4.75 6v2a.75.75 0 0 1-1.5 0V6c0-.487.127-.944.349-1.34l-1.13-1.13a.75.75 0 0 1 0-1.06ZM15.25 4a.75.75 0 0 1 .75-.75h2A2.75 2.75 0 0 1 20.75 6v2a.75.75 0 0 1-1.5 0V6A1.25 1.25 0 0 0 18 4.75h-2a.75.75 0 0 1-.75-.75M4 15.25a.75.75 0 0 1 .75.75v2A1.25 1.25 0 0 0 6 19.25h2a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18v-2a.75.75 0 0 1 .75-.75"/></svg>`,
};
export const iconFullscreenOn24: {
  name: 'fullscreen-on-24';
  data: string;
} = {
  name: 'fullscreen-on-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M6 4.75A1.25 1.25 0 0 0 4.75 6v2a.75.75 0 0 1-1.5 0V6A2.75 2.75 0 0 1 6 3.25h2a.75.75 0 0 1 0 1.5zM15.25 4a.75.75 0 0 1 .75-.75h2A2.75 2.75 0 0 1 20.75 6v2a.75.75 0 0 1-1.5 0V6A1.25 1.25 0 0 0 18 4.75h-2a.75.75 0 0 1-.75-.75M4 15.25a.75.75 0 0 1 .75.75v2A1.25 1.25 0 0 0 6 19.25h2a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 18v-2a.75.75 0 0 1 .75-.75m16 0a.75.75 0 0 1 .75.75v2A2.75 2.75 0 0 1 18 20.75h-2a.75.75 0 0 1 0-1.5h2A1.25 1.25 0 0 0 19.25 18v-2a.75.75 0 0 1 .75-.75"/></svg>`,
};
export const iconGas24: {
  name: 'gas-24';
  data: string;
} = {
  name: 'gas-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M7.302 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2m11 10.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-13-5.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4.667 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6.333-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0m4 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m-1.25-7a.75.75 0 0 1-.75.75h-7a.75.75 0 0 1 0-1.5h7a.75.75 0 0 1 .75.75M7.302 17.75a.75.75 0 0 0 0 1.5h7a.75.75 0 0 0 0-1.5z"/></svg>`,
};
export const iconGlobalSettings24: {
  name: 'global-settings-24';
  data: string;
} = {
  name: 'global-settings-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M11.61 2.258q.39-.015.78 0a.8.8 0 0 1 .3.016A9.75 9.75 0 0 1 21.75 12a.75.75 0 0 1-1.5 0 8.3 8.3 0 0 0-.313-2.25h-4.252a17.8 17.8 0 0 1 .085 3.687.75.75 0 1 1-1.496-.122c.098-1.195.062-2.39-.102-3.565H9.829a16.3 16.3 0 0 0 0 4.5H12.5a.75.75 0 0 1 0 1.5h-2.39a16.3 16.3 0 0 0 1.812 4.5h.097a.75.75 0 1 1 .004 1.5q-.207 0-.414-.008a.8.8 0 0 1-.299-.016 9.751 9.751 0 0 1 0-19.452.8.8 0 0 1 .3-.016m.312 1.492h.156a16.2 16.2 0 0 1 1.812 4.5h-3.78a16.3 16.3 0 0 1 1.812-4.5m7.427 4.5h-3.921a17.7 17.7 0 0 0-1.518-4.276 8.25 8.25 0 0 1 5.439 4.276M10.09 20.026a17.8 17.8 0 0 1-1.517-4.276H4.652a8.25 8.25 0 0 0 5.438 4.276M8.315 14.25a17.8 17.8 0 0 1 0-4.5H4.063a8.25 8.25 0 0 0 0 4.5zM10.09 3.974A17.8 17.8 0 0 0 8.573 8.25H4.652a8.25 8.25 0 0 1 5.438-4.276M19.751 15.5v.854c.435.124.837.353 1.166.674l.74-.427a.75.75 0 0 1 .75 1.299l-.74.427a2.75 2.75 0 0 1 0 1.346l.74.427a.75.75 0 1 1-.749 1.3l-.74-.428c-.33.32-.732.55-1.167.674v.854a.75.75 0 0 1-1.5 0v-.854a2.75 2.75 0 0 1-1.166-.673l-.74.427a.75.75 0 1 1-.75-1.3l.74-.426a2.75 2.75 0 0 1 0-1.348l-.74-.426a.75.75 0 1 1 .75-1.3l.74.427c.33-.32.731-.55 1.166-.673V15.5a.75.75 0 0 1 1.5 0m-2 3.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"/></svg>`,
};
export const iconGoal24: {
  name: 'goal-24';
  data: string;
} = {
  name: 'goal-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M20.533 7.278a9.75 9.75 0 0 1 1.157 5.806.75.75 0 0 1-1.49-.168 8.25 8.25 0 1 0-7.283 7.28.75.75 0 1 1 .166 1.49 9.75 9.75 0 1 1 7.45-14.408M17.75 12A5.75 5.75 0 1 0 12 17.75a.75.75 0 0 0 0-1.5A4.25 4.25 0 1 1 16.25 12a.75.75 0 0 0 1.5 0m-4 0a1.75 1.75 0 1 0-1.162 1.648l1.662 1.663V18c0 .199.079.39.22.53l3 3a.75.75 0 0 0 1.28-.53v-2.25H21a.75.75 0 0 0 .53-1.28l-3-3a.75.75 0 0 0-.53-.22h-2.69l-1.662-1.662A1.8 1.8 0 0 0 13.75 12m2 5.69v-1.94h1.94l1.5 1.5H18a.75.75 0 0 0-.75.75v1.19z"/></svg>`,
};
export const iconGreater24: {
  name: 'greater-24';
  data: string;
} = {
  name: 'greater-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M4.31 5.705a.75.75 0 0 1 .985-.394l14 6a.75.75 0 0 1 0 1.378l-14 6a.75.75 0 1 1-.59-1.378L17.096 12 4.705 6.69a.75.75 0 0 1-.394-.985Z"/></svg>`,
};
export const iconGrid24: {
  name: 'grid-24';
  data: string;
} = {
  name: 'grid-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5 4.75a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4A.25.25 0 0 0 9.25 9V5A.25.25 0 0 0 9 4.75zm-1.237-.987A1.75 1.75 0 0 1 5 3.25h4A1.75 1.75 0 0 1 10.75 5v4A1.75 1.75 0 0 1 9 10.75H5A1.75 1.75 0 0 1 3.25 9V5c0-.464.184-.91.513-1.237M15 4.75a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25V5a.25.25 0 0 0-.25-.25zm-1.237-.987A1.75 1.75 0 0 1 15 3.25h4A1.75 1.75 0 0 1 20.75 5v4A1.75 1.75 0 0 1 19 10.75h-4A1.75 1.75 0 0 1 13.25 9V5c0-.464.184-.91.513-1.237M5 14.75a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25zm-1.237-.987A1.75 1.75 0 0 1 5 13.25h4A1.75 1.75 0 0 1 10.75 15v4A1.75 1.75 0 0 1 9 20.75H5A1.75 1.75 0 0 1 3.25 19v-4c0-.464.184-.91.513-1.237M15 14.75a.25.25 0 0 0-.25.25v4a.25.25 0 0 0 .25.25h4a.25.25 0 0 0 .25-.25v-4a.25.25 0 0 0-.25-.25zm-1.237-.987A1.75 1.75 0 0 1 15 13.25h4A1.75 1.75 0 0 1 20.75 15v4A1.75 1.75 0 0 1 19 20.75h-4A1.75 1.75 0 0 1 13.25 19v-4c0-.464.184-.91.513-1.237"/></svg>`,
};
export const iconHomeOutline16: {
  name: 'home-outline-16';
  data: string;
} = {
  name: 'home-outline-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M7.999 2.958a.7.7 0 0 0-.22.035.8.8 0 0 0-.21.11l-4 3.001a.7.7 0 0 0-.278.563v6a.66.66 0 0 0 .209.5.66.66 0 0 0 .499.208H6.04V8.708h3.916v4.667H12c.2 0 .355-.064.5-.208a.66.66 0 0 0 .208-.5v-6a.7.7 0 0 0-.278-.563l-.005-.004-3.996-2.997a.8.8 0 0 0-.21-.11.7.7 0 0 0-.22-.035m-.614-1.151a1.93 1.93 0 0 1 1.782.287l.007.006 3.998 2.998a1.95 1.95 0 0 1 .786 1.568v6a1.9 1.9 0 0 1-.575 1.384 1.9 1.9 0 0 1-1.384.575H8.707V9.958H7.291v4.667H3.999a1.9 1.9 0 0 1-1.383-.575 1.9 1.9 0 0 1-.575-1.383v-6c0-.309.07-.605.208-.88l.559.28-.56-.28a1.9 1.9 0 0 1 .578-.689l4.005-3.004q.255-.185.554-.287"/></svg>`,
};
export const iconHomeOutline24: {
  name: 'home-outline-24';
  data: string;
} = {
  name: 'home-outline-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12 4.25q-.206 0-.388.062-.18.058-.367.192l-6.001 4.5c-.152.112-.27.252-.36.43v.002c-.09.18-.134.364-.134.564v9c0 .35.116.63.368.883.252.251.532.367.882.367h3.25v-7h5.5v7H18c.35 0 .63-.116.883-.367A1.18 1.18 0 0 0 19.25 19v-9a1.24 1.24 0 0 0-.494-.995L18.75 9l-5.995-4.496a1.4 1.4 0 0 0-.367-.192A1.2 1.2 0 0 0 12 4.25m-.862-1.362q.418-.138.862-.138a2.73 2.73 0 0 1 1.642.543l.008.007 5.997 4.498c.347.255.618.58.812.966v.001q.29.584.291 1.235v9c0 .75-.276 1.411-.806 1.943h-.001A2.68 2.68 0 0 1 18 21.75h-4.75v-7h-2.5v7H6c-.75 0-1.411-.276-1.942-.807A2.68 2.68 0 0 1 3.25 19v-9c0-.433.098-.848.292-1.236l.671.336-.671-.335c.193-.386.464-.712.811-.967l6.006-4.505q.36-.264.779-.405"/></svg>`,
};
export const iconImport24: {
  name: 'import-24';
  data: string;
} = {
  name: 'import-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M4.895 4.864c-.319 0-.615.12-.827.318a.97.97 0 0 0-.318.71v9.778c0 .257.108.513.318.71.212.199.508.318.827.318h6.631a.75.75 0 0 1 0 1.5H4.895a2.7 2.7 0 0 1-1.853-.724 2.47 2.47 0 0 1-.792-1.804V5.892c0-.686.291-1.334.792-1.804a2.7 2.7 0 0 1 1.853-.724h3.79a.75.75 0 0 1 .512.204l2.626 2.463h6.335a2.7 2.7 0 0 1 1.853.724c.5.47.792 1.118.792 1.804v3.111a.75.75 0 0 1-1.5 0V8.56a.97.97 0 0 0-.319-.71 1.2 1.2 0 0 0-.826-.318h-6.632a.75.75 0 0 1-.513-.203L8.387 4.864zm9.908 12.037 2.842-2.667a.75.75 0 0 1 1.026 0l2.842 2.667a.75.75 0 0 1-1.026 1.094l-1.58-1.482v3.601a.75.75 0 0 1-1.5 0v-3.6l-1.578 1.48a.75.75 0 0 1-1.026-1.093"/></svg>`,
};
export const iconInfo16: {
  name: 'info-16';
  data: string;
} = {
  name: 'info-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.315 3.315a6.625 6.625 0 1 1 9.369 9.37 6.625 6.625 0 0 1-9.37-9.37Zm4.684-.69a5.375 5.375 0 1 0 0 10.75 5.375 5.375 0 0 0 0-10.75M7.374 6c0-.345.28-.625.625-.625h.007a.625.625 0 1 1 0 1.25h-.007A.625.625 0 0 1 7.374 6m-.666 2c0-.345.28-.625.625-.625h.666c.345 0 .625.28.625.625v2.042h.042a.625.625 0 1 1 0 1.25h-.667a.625.625 0 0 1-.625-.625V8.625h-.041A.625.625 0 0 1 6.708 8"/></svg>`,
};
export const iconInfo24: {
  name: 'info-24';
  data: string;
} = {
  name: 'info-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5.106 5.106a9.75 9.75 0 1 1 13.788 13.788A9.75 9.75 0 0 1 5.106 5.106M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5M11.25 9a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75m-1 3a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .75.75v3.25H13a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75v-3.25H11a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconInfoFilled16: {
  name: 'info-filled-16';
  data: string;
} = {
  name: 'info-filled-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 1.333A6.667 6.667 0 0 1 14.667 8a6.666 6.666 0 0 1-13.33.216L1.334 8l.002-.187A6.666 6.666 0 0 1 8 1.333m0 6h-.666l-.078.005a.667.667 0 0 0 0 1.324l.078.005v2l.004.078a.67.67 0 0 0 .584.584l.078.004h.667l.078-.004a.67.67 0 0 0 .584-.584l.005-.078-.005-.078a.67.67 0 0 0-.51-.572l-.074-.013L8.667 10V8l-.005-.078a.67.67 0 0 0-.584-.584zm.007-2-.085.005a.667.667 0 0 0 0 1.324L8 6.667l.085-.005a.667.667 0 0 0 0-1.324z"/></svg>`,
};
export const iconInfoFilled24: {
  name: 'info-filled-24';
  data: string;
} = {
  name: 'info-filled-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12.001 2c5.523 0 10 4.475 10 9.996a9.994 9.994 0 0 1-9.838 10.003 10 10 0 0 1-10.157-9.68l-.005-.323.004-.28C2.153 6.326 6.571 2 12.001 2m0 8.996h-1l-.117.007a1 1 0 0 0 0 1.986l.117.007v2.998l.007.117a1 1 0 0 0 .876.876l.117.007h1l.117-.007a1 1 0 0 0 .876-.876l.007-.117-.007-.117a1 1 0 0 0-.764-.856l-.112-.02-.117-.006v-2.999l-.007-.117a1 1 0 0 0-.876-.876zm.01-2.998-.127.007a1 1 0 0 0 0 1.985l.117.007.127-.007a1 1 0 0 0 0-1.985z"/></svg>`,
};
export const iconInfoTriangle24: {
  name: 'info-triangle-24';
  data: string;
} = {
  name: 'info-triangle-24',
  data: `<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M10.692 2.26a2.664 2.664 0 0 1 3.586.942l.002.003 8.112 13.547a2.664 2.664 0 0 1-2.277 3.994H3.884a2.664 2.664 0 0 1-2.277-3.996l.006-.01L9.705 3.229l.016-.027c.237-.392.572-.716.97-.941m1.307 1.158a1.16 1.16 0 0 0-.993.559L2.903 17.505a1.164 1.164 0 0 0 .994 1.741h16.205a1.165 1.165 0 0 0 .994-1.74L12.995 3.979v-.002A1.16 1.16 0 0 0 12 3.418m0 4.832a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V9a.75.75 0 0 1 .75-.75M11.25 16a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconInfoTriangleFilled16: {
  name: 'info-triangle-filled-16';
  data: string;
} = {
  name: 'info-triangle-filled-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M8 1.113c.636 0 1.23.312 1.593.832l.07.106 5.41 9.032a1.942 1.942 0 0 1-1.539 2.909l-.13.005H2.588a1.943 1.943 0 0 1-1.722-2.8l.066-.123L6.34 2.049A1.94 1.94 0 0 1 8 1.113m0 6.22h-.667l-.078.005a.667.667 0 0 0 0 1.324l.078.005v2l.005.078a.67.67 0 0 0 .584.584l.078.004h.666l.078-.004a.666.666 0 0 0 .584-.584l.005-.078-.005-.078a.67.67 0 0 0-.51-.572l-.074-.013L8.666 10V8l-.004-.078a.67.67 0 0 0-.584-.584zm.006-2-.084.005a.667.667 0 0 0 0 1.324L8 6.667l.084-.005a.667.667 0 0 0 0-1.324z"/></svg>`,
};
export const iconInfoTriangleFilled24: {
  name: 'info-triangle-filled-24';
  data: string;
} = {
  name: 'info-triangle-filled-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 1.67c.955 0 1.845.467 2.39 1.247l.105.16 8.114 13.548a2.913 2.913 0 0 1-2.307 4.363l-.195.008H3.882a2.913 2.913 0 0 1-2.582-4.2l.099-.185 8.11-13.538A2.91 2.91 0 0 1 12 1.67M12 11h-1l-.117.007a1 1 0 0 0 0 1.986L11 13v3l.007.117a1 1 0 0 0 .876.876L12 17h1l.117-.007a1 1 0 0 0 .876-.876L14 16l-.007-.117a1 1 0 0 0-.764-.857l-.112-.02L13 15v-3l-.007-.117a1 1 0 0 0-.876-.876zm.01-3-.127.007a1 1 0 0 0 0 1.986L12 10l.127-.007a1 1 0 0 0 0-1.986z"/></svg>`,
};
export const iconKnowledgebase24: {
  name: 'knowledgebase-24';
  data: string;
} = {
  name: 'knowledgebase-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M3.75 6.446v11.348a9.75 9.75 0 0 1 7.5 0V6.446a8.25 8.25 0 0 0-7.5 0m9 0v11.348a9.75 9.75 0 0 1 7.5 0V6.446a8.25 8.25 0 0 0-7.5 0M12 5.145a9.75 9.75 0 0 0-9.375.205.75.75 0 0 0-.375.65v13a.75.75 0 0 0 1.125.65 8.25 8.25 0 0 1 8.25 0 .75.75 0 0 0 .75 0 8.25 8.25 0 0 1 8.25 0A.75.75 0 0 0 21.75 19V6a.75.75 0 0 0-.375-.65A9.75 9.75 0 0 0 12 5.145"/></svg>`,
};
export const iconLayers24: {
  name: 'layers-24';
  data: string;
} = {
  name: 'layers-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M9.116 5.116A1.25 1.25 0 0 1 10 4.75h8A1.25 1.25 0 0 1 19.25 6v8A1.25 1.25 0 0 1 18 15.25h-8A1.25 1.25 0 0 1 8.75 14V6c0-.332.132-.65.366-.884M7.25 7.25V6A2.75 2.75 0 0 1 10 3.25h8A2.75 2.75 0 0 1 20.75 6v8A2.75 2.75 0 0 1 18 16.75h-1.25V18A2.75 2.75 0 0 1 14 20.75H6A2.75 2.75 0 0 1 3.25 18v-8A2.75 2.75 0 0 1 6 7.25zm8 9.5V18A1.25 1.25 0 0 1 14 19.25H6A1.25 1.25 0 0 1 4.75 18v-8A1.25 1.25 0 0 1 6 8.75h1.25V14A2.75 2.75 0 0 0 10 16.75z"/></svg>`,
};
export const iconLiquid24: {
  name: 'liquid-24';
  data: string;
} = {
  name: 'liquid-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12.001 1.25a.75.75 0 0 1 .62.327l6.062 8.877.025.038c1.89 3.165 1.149 7.178-1.738 9.514-2.876 2.328-7.063 2.328-9.94 0-2.887-2.335-3.629-6.35-1.739-9.514l.025-.038 6.066-8.877a.75.75 0 0 1 .62-.327ZM6.568 11.28c-1.486 2.51-.906 5.69 1.406 7.56 2.327 1.882 5.726 1.882 8.052 0 2.311-1.87 2.892-5.05 1.405-7.56l-5.43-7.95z"/></svg>`,
};
export const iconLiquidGas24: {
  name: 'liquid-gas-24';
  data: string;
} = {
  name: 'liquid-gas-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12.62 1.577a.75.75 0 0 0-1.238 0l-6.066 8.877a7.3 7.3 0 0 0-.996 4.796H2.25a.75.75 0 0 0 0 1.5h2.443a7.5 7.5 0 0 0 2.337 3.256c2.877 2.328 7.064 2.328 9.94 0 2.231-1.805 3.181-4.613 2.625-7.256h1.655a.75.75 0 0 0 0-1.5h-2.146a8 8 0 0 0-.42-.796zm4.79 9.673L12 3.33l-5.432 7.95a5.8 5.8 0 0 0-.73 3.97h5.412a.75.75 0 0 1 0 1.5H6.318c.374.785.93 1.502 1.656 2.09 2.327 1.882 5.726 1.882 8.052 0 1.878-1.52 2.614-3.904 2.026-6.09H12.25a.75.75 0 0 1 0-1.5zM13 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-4.25 5a1 1 0 1 0 0-2 1 1 0 0 0 0 2m6.5 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/></svg>`,
};
export const iconList24: {
  name: 'list-24';
  data: string;
} = {
  name: 'list-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M4 5.364a.75.75 0 0 1 .75.75v.01a.75.75 0 1 1-1.5 0v-.01a.75.75 0 0 1 .75-.75m3.25.75a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M4 11.364a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75m3.25.75a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75M4 17.364a.75.75 0 0 1 .75.75v.01a.75.75 0 0 1-1.5 0v-.01a.75.75 0 0 1 .75-.75m3.25.75a.75.75 0 0 1 .75-.75h11a.75.75 0 0 1 0 1.5H8a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconMail16: {
  name: 'mail-16';
  data: string;
} = {
  name: 'mail-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.333 3.958a.71.71 0 0 0-.646.416L8 7.915l5.312-3.54a.71.71 0 0 0-.645-.417zm10.041 1.876L8.346 9.187a.63.63 0 0 1-.693 0L2.624 5.834v5.5a.71.71 0 0 0 .709.708h9.333a.71.71 0 0 0 .708-.709zM1.948 3.282a1.96 1.96 0 0 1 1.385-.574h9.333a1.96 1.96 0 0 1 1.958 1.959v6.666a1.96 1.96 0 0 1-1.958 1.959H3.333a1.96 1.96 0 0 1-1.959-1.959V4.667c0-.52.207-1.018.574-1.385"/></svg>`,
};
export const iconMenu16: {
  name: 'menu-16';
  data: string;
} = {
  name: 'menu-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M2.417 7.087a1.292 1.292 0 1 1 1.827 1.826 1.292 1.292 0 0 1-1.827-1.826m.914.871a.042.042 0 1 0 0 .084.042.042 0 0 0 0-.084m3.753-.871a1.292 1.292 0 1 1 1.827 1.826 1.292 1.292 0 0 1-1.827-1.826m.913.871a.042.042 0 1 0 0 .084.042.042 0 0 0 0-.084m3.754-.871a1.292 1.292 0 1 1 1.827 1.827 1.292 1.292 0 0 1-1.827-1.827m.913.871a.042.042 0 1 0 0 .083.042.042 0 0 0 0-.083"/></svg>`,
};
export const iconMenuDots24: {
  name: 'menu-dots-24';
  data: string;
} = {
  name: 'menu-dots-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M7 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0"/></svg>`,
};
export const iconMinimise24: {
  name: 'minimise-24';
  data: string;
} = {
  name: 'minimise-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M3.25 20a.75.75 0 0 1 .75-.75h16a.75.75 0 0 1 0 1.5H4a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconOpex24: {
  name: 'opex-24';
  data: string;
} = {
  name: 'opex-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5.792 2.681c1.992-.575 4.424-.575 6.416 0 .999.289 1.856.713 2.479 1.252.623.54 1.063 1.245 1.063 2.067s-.44 1.528-1.063 2.067-1.48.963-2.479 1.252c-1.992.575-4.424.575-6.416 0-.782-.226-1.478-.535-2.042-.918V11c0 .188.068.363.299.576.253.235.661.473 1.258.74a.75.75 0 0 1-.614 1.368 9 9 0 0 1-.943-.48V16c0 .189.068.363.299.576.253.235.661.473 1.258.74a.75.75 0 0 1-.614 1.369c-.631-.284-1.223-.602-1.663-1.008-.462-.427-.78-.977-.78-1.677V6c0-.822.44-1.528 1.063-2.067s1.48-.963 2.479-1.252M3.75 6c0 .25.132.575.545.933s1.056.697 1.913.944c1.72.497 3.864.497 5.584 0 .857-.247 1.5-.586 1.913-.944s.545-.683.545-.933-.132-.575-.545-.933-1.056-.697-1.913-.944c-1.72-.497-3.864-.497-5.584 0-.857.247-1.5.586-1.913.944S3.75 5.75 3.75 6m6.672 5.208c1.21-.605 2.83-.958 4.578-.958s3.368.353 4.578.958c1.166.583 2.172 1.526 2.172 2.792v4c0 1.265-1.006 2.209-2.172 2.792-1.21.605-2.83.958-4.578.958s-3.368-.353-4.578-.958C9.256 20.209 8.25 19.265 8.25 18v-4c0-1.266 1.006-2.21 2.172-2.792M9.75 16.4V18c0 .39.337.947 1.343 1.45.96.48 2.341.8 3.907.8s2.946-.32 3.907-.8c1.006-.503 1.343-1.06 1.343-1.45v-1.6c-.213.145-.44.276-.672.392-1.21.605-2.83.958-4.578.958s-3.368-.353-4.578-.958a6 6 0 0 1-.672-.391Zm10.5-2.4c0 .391-.337.948-1.343 1.45-.96.481-2.341.8-3.907.8s-2.946-.319-3.907-.8C10.087 14.948 9.75 14.391 9.75 14s.337-.948 1.343-1.45c.96-.481 2.341-.8 3.907-.8s2.946.319 3.907.8c1.006.502 1.343 1.059 1.343 1.45"/></svg>`,
};
export const iconOrders24: {
  name: 'orders-24';
  data: string;
} = {
  name: 'orders-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M10.603 2.882a.75.75 0 1 0-1.5 0v1.015H6.765c-.902 0-1.633.73-1.633 1.632v14.118c0 .902.731 1.632 1.633 1.632h11.47c.902 0 1.633-.73 1.633-1.632V5.53c0-.901-.731-1.632-1.633-1.632h-2.338V2.882a.75.75 0 0 0-1.5 0v1.015h-3.794zm-1.5 2.515v.132a.75.75 0 1 0 1.5 0v-.132h3.794v.132a.75.75 0 1 0 1.5 0v-.132h2.338c.073 0 .133.06.133.132v14.118c0 .073-.06.132-.133.132H6.765a.13.13 0 0 1-.133-.132V5.53c0-.073.06-.132.133-.132h2.338ZM8.97 8.75a.75.75 0 1 0 0 1.5h7.058a.75.75 0 0 0 0-1.5zm0 3.53a.75.75 0 0 0 0 1.5h5.294a.75.75 0 0 0 0-1.5zm0 3.529a.75.75 0 0 0 0 1.5h3.53a.75.75 0 0 0 0-1.5z"/></svg>`,
};
export const iconOutbreak16: {
  name: 'outbreak-16';
  data: string;
} = {
  name: 'outbreak-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M10.25 2.625a.625.625 0 1 1 0-1.25H14a.625.625 0 0 1 .625.625v3.75a.625.625 0 1 1-1.25 0V3.509L7.692 9.192a.625.625 0 1 1-.884-.884l5.683-5.683zm-8.253.872A2.13 2.13 0 0 1 3.5 2.875H8a.625.625 0 1 1 0 1.25H3.5A.875.875 0 0 0 2.625 5v7.5a.875.875 0 0 0 .875.875H11a.875.875 0 0 0 .875-.875V8a.625.625 0 1 1 1.25 0v4.5A2.125 2.125 0 0 1 11 14.625H3.5A2.125 2.125 0 0 1 1.375 12.5V5c0-.564.224-1.104.622-1.503"/></svg>`,
};
export const iconOutbreak24: {
  name: 'outbreak-24';
  data: string;
} = {
  name: 'outbreak-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M14.25 6.75a.75.75 0 0 1 0-1.5H18a.75.75 0 0 1 .75.75v3.75a.75.75 0 0 1-1.5 0V7.81l-5.47 5.47a.75.75 0 1 1-1.06-1.06l5.47-5.47zm-8.341.659A2.25 2.25 0 0 1 7.5 6.75H12a.75.75 0 0 1 0 1.5H7.5a.75.75 0 0 0-.75.75v7.5a.75.75 0 0 0 .75.75H15a.75.75 0 0 0 .75-.75V12a.75.75 0 0 1 1.5 0v4.5A2.25 2.25 0 0 1 15 18.75H7.5a2.25 2.25 0 0 1-2.25-2.25V9c0-.597.237-1.169.659-1.591"/></svg>`,
};
export const iconPuzzle24: {
  name: 'puzzle-24';
  data: string;
} = {
  name: 'puzzle-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M10 3.75A1.25 1.25 0 0 0 8.75 5v1A1.75 1.75 0 0 1 7 7.75H4a.25.25 0 0 0-.25.25v3a.25.25 0 0 0 .25.25h1a2.75 2.75 0 1 1 0 5.5H4a.25.25 0 0 0-.25.25v3a.25.25 0 0 0 .25.25h3a.25.25 0 0 0 .25-.25v-1a2.75 2.75 0 0 1 5.5 0v1a.25.25 0 0 0 .25.25h3a.25.25 0 0 0 .25-.25v-3A1.75 1.75 0 0 1 18 15.25h1a1.25 1.25 0 0 0 0-2.5h-1A1.75 1.75 0 0 1 16.25 11V8a.25.25 0 0 0-.25-.25h-3A1.75 1.75 0 0 1 11.25 6V5A1.25 1.25 0 0 0 10 3.75m-1.945-.695A2.75 2.75 0 0 1 12.75 5v1a.25.25 0 0 0 .25.25h3A1.75 1.75 0 0 1 17.75 8v3a.25.25 0 0 0 .25.25h1a2.75 2.75 0 1 1 0 5.5h-1a.25.25 0 0 0-.25.25v3A1.75 1.75 0 0 1 16 21.75h-3A1.75 1.75 0 0 1 11.25 20v-1a1.25 1.25 0 0 0-2.5 0v1A1.75 1.75 0 0 1 7 21.75H4A1.75 1.75 0 0 1 2.25 20v-3A1.75 1.75 0 0 1 4 15.25h1a1.25 1.25 0 0 0 0-2.5H4A1.75 1.75 0 0 1 2.25 11V8A1.75 1.75 0 0 1 4 6.25h3A.25.25 0 0 0 7.25 6V5c0-.73.29-1.429.805-1.945"/></svg>`,
};
export const iconRefresh16: {
  name: 'refresh-16';
  data: string;
} = {
  name: 'refresh-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M4.97 2.86a6.025 6.025 0 0 1 8.981 4.387.625.625 0 1 1-1.238.172 4.775 4.775 0 0 0-8.667-2.044h1.286a.625.625 0 1 1 0 1.25H2.665A.625.625 0 0 1 2.04 6V3.333a.625.625 0 1 1 1.25 0v.965A6 6 0 0 1 4.97 2.86M2.58 8.048a.625.625 0 0 1 .705.533 4.775 4.775 0 0 0 8.666 2.044h-1.286a.625.625 0 1 1 0-1.25h2.668c.344 0 .624.28.624.625v2.667a.625.625 0 0 1-1.25 0v-.965a6.023 6.023 0 0 1-8.932.502 6.03 6.03 0 0 1-1.729-3.451.625.625 0 0 1 .533-.706Z"/></svg>`,
};
export const iconRequest24: {
  name: 'request-24';
  data: string;
} = {
  name: 'request-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M6.116 4.116A1.25 1.25 0 0 1 7 3.75h6.25V7A1.75 1.75 0 0 0 15 8.75h3.25V19A1.25 1.25 0 0 1 17 20.25H7A1.25 1.25 0 0 1 5.75 19V5c0-.332.132-.65.366-.884M17.19 7.25l-2.44-2.44V7a.25.25 0 0 0 .25.25zM7 2.25A2.75 2.75 0 0 0 4.25 5v14A2.75 2.75 0 0 0 7 21.75h10A2.75 2.75 0 0 0 19.75 19V8a.75.75 0 0 0-.22-.53l-5-5a.75.75 0 0 0-.53-.22zM12.75 11a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V17a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25z"/></svg>`,
};
export const iconReset16: {
  name: 'reset-16';
  data: string;
} = {
  name: 'reset-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M9.172 3.44a4.71 4.71 0 0 0-5.1 1.935Zm-5.1 1.935H6a.625.625 0 1 1 0 1.25H2.666A.625.625 0 0 1 2.041 6V2.667a.625.625 0 0 1 1.25 0v1.655A5.96 5.96 0 0 1 9.483 2.23a5.958 5.958 0 1 1-7.392 6.545.625.625 0 0 1 1.24-.162 4.708 4.708 0 1 0 5.84-5.173"/></svg>`,
};
export const iconSave16: {
  name: 'save-16';
  data: string;
} = {
  name: 'save-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M3.999 3.292A.71.71 0 0 0 3.29 4v8a.71.71 0 0 0 .708.708h8a.71.71 0 0 0 .708-.708V5.592l-2.3-2.3h-.45v2.041c0 .346-.28.625-.625.625h-4a.625.625 0 0 1-.625-.625V3.292zm0-1.25A1.96 1.96 0 0 0 2.04 4v8a1.96 1.96 0 0 0 1.958 1.958h8A1.96 1.96 0 0 0 13.957 12V5.333a.63.63 0 0 0-.183-.442l-2.666-2.666a.63.63 0 0 0-.443-.183zm1.958 1.25v1.416h2.75V3.292zm.657 4.657a1.958 1.958 0 1 1 2.77 2.77 1.958 1.958 0 0 1-2.77-2.77M8 8.625a.708.708 0 1 0 0 1.417.708.708 0 0 0 0-1.417"/></svg>`,
};
export const iconSave24: {
  name: 'save-24';
  data: string;
} = {
  name: 'save-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M5.116 5.116A1.25 1.25 0 0 1 6 4.75h1.25V8c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75V4.75h.94l3.56 3.56V18A1.25 1.25 0 0 1 18 19.25H6A1.25 1.25 0 0 1 4.75 18V6c0-.332.132-.65.366-.884m8.134-.366v2.5h-4.5v-2.5zm.75-1.5h2a.75.75 0 0 1 .53.22l4 4c.141.14.22.331.22.53v10A2.75 2.75 0 0 1 18 20.75H6A2.75 2.75 0 0 1 3.25 18V6A2.75 2.75 0 0 1 6 3.25zm-2 8a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5m-.884 1.866a1.25 1.25 0 1 1 1.768 1.768 1.25 1.25 0 0 1-1.768-1.768"/></svg>`,
};
export const iconSearch16: {
  name: 'search-16';
  data: string;
} = {
  name: 'search-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M4.64 1.778a5.292 5.292 0 0 1 6.183 8.162l3.618 3.618a.625.625 0 1 1-.884.884l-3.618-3.618a5.29 5.29 0 0 1-8.565-4.157 5.29 5.29 0 0 1 3.267-4.89Zm2.026.847a4.042 4.042 0 1 0 0 8.083 4.042 4.042 0 0 0 0-8.083"/></svg>`,
};
export const iconSearch24: {
  name: 'search-24';
  data: string;
} = {
  name: 'search-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M7.294 3.31a7.361 7.361 0 0 1 8.526 11.45l5.211 5.21a.75.75 0 1 1-1.06 1.061l-5.211-5.21A7.36 7.36 0 1 1 7.294 3.31m2.817.94a5.861 5.861 0 1 0 0 11.722 5.861 5.861 0 0 0 0-11.722"/></svg>`,
};
export const iconShare16: {
  name: 'share-16';
  data: string;
} = {
  name: 'share-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15"><path fill-rule="evenodd" d="M10.141 1.586a2.625 2.625 0 1 1-.16 3.538l-3.418 1.76a2.6 2.6 0 0 1 0 1.116L9.98 9.762a2.624 2.624 0 1 1-.549 1.123L6.014 9.124a2.62 2.62 0 0 1-2.017.944 2.625 2.625 0 1 1 2.017-4.306L9.432 4a2.63 2.63 0 0 1 .71-2.414Zm.637 2.493-.038-.08a1.375 1.375 0 1 1 .038.08M5.217 6.807a1.374 1.374 0 1 0-2.437 1.27 1.374 1.374 0 0 0 2.437-1.27m5.523 4.079A1.375 1.375 0 1 0 13.255 12a1.375 1.375 0 0 0-2.515-1.114"/></svg>`,
};
export const iconShare24: {
  name: 'share-24';
  data: string;
} = {
  name: 'share-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M15.348 3.348a3.75 3.75 0 1 1-.322 4.937l-5.395 2.779a3.75 3.75 0 0 1 0 1.872l5.395 2.78a3.75 3.75 0 1 1-.658 1.349l-5.394-2.78a3.75 3.75 0 1 1 0-4.57l5.395-2.779a3.75 3.75 0 0 1 .98-3.588ZM16 7.031a1 1 0 0 0-.053-.11 2.249 2.249 0 1 1 .053.11M8 10.97a2.25 2.25 0 1 0 0 2.062 1 1 0 0 1 .053-.11 2.25 2.25 0 0 0 0-1.841A1 1 0 0 1 8 10.97m7.947 6.11a2.25 2.25 0 1 0 .053-.11 1 1 0 0 1-.053.11"/></svg>`,
};
export const iconSlider24: {
  name: 'slider-24';
  data: string;
} = {
  name: 'slider-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12.056 4.055a2.75 2.75 0 0 1 4.59 1.195H20a.75.75 0 0 1 0 1.5h-3.354a2.75 2.75 0 0 1-5.292 0H4a.75.75 0 0 1 0-1.5h7.354a2.75 2.75 0 0 1 .702-1.195M14 4.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-7.945 5.306a2.75 2.75 0 0 1 4.59 1.194H20a.75.75 0 0 1 0 1.5h-9.354a2.75 2.75 0 0 1-5.292 0H4a.75.75 0 0 1 0-1.5h1.354a2.75 2.75 0 0 1 .701-1.194M8 10.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m7.056 5.305a2.75 2.75 0 0 1 4.59 1.195H20a.75.75 0 0 1 0 1.5h-.354a2.75 2.75 0 0 1-5.292 0H4a.75.75 0 0 1 0-1.5h10.354a2.75 2.75 0 0 1 .702-1.195M17 16.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"/></svg>`,
};
export const iconSolid24: {
  name: 'solid-24';
  data: string;
} = {
  name: 'solid-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M10.628 1.614a2.77 2.77 0 0 1 2.744 0l7 4.007v.001c.35.199.65.472.88.799a.75.75 0 0 1 .198.328c.196.383.3.808.3 1.24v8.019c0 .98-.527 1.881-1.377 2.369l-7 4.008a2.77 2.77 0 0 1-2.745 0l-7-4.008A2.73 2.73 0 0 1 2.25 16.01V7.991c0-.44.106-.863.3-1.24a.75.75 0 0 1 .2-.332c.227-.321.524-.594.877-.797zM3.75 8.104v7.905c0 .438.235.845.622 1.066l6.878 3.938v-8.58l-7.5-4.33Zm9 4.329v8.58l6.877-3.938a1.23 1.23 0 0 0 .623-1.067V8.103zm6.71-5.605-6.832-3.912a1.27 1.27 0 0 0-1.256 0L4.541 6.828 12 11.134z"/></svg>`,
};
export const iconStreamInput16: {
  name: 'stream-input-16';
  data: string;
} = {
  name: 'stream-input-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M2.783 8.283a.625.625 0 0 1 .884 0l2.393 2.393a.623.623 0 0 1 .007.891l-2.4 2.4a.625.625 0 1 1-.884-.884l1.333-1.333H1.625a.625.625 0 1 1 0-1.25h2.491L2.783 9.167a.625.625 0 0 1 0-.884M6.25 6.625a4.375 4.375 0 0 1 4.375-4.375h1a.625.625 0 1 0 0-1.25h-1A5.625 5.625 0 0 0 5 6.625c0 .341-.124.653-.33.894l.885.885a2.62 2.62 0 0 0 .695-1.779"/><path d="M7.437 10.643a1.9 1.9 0 0 0-.499-.856l-.206-.206c.477-.513.768-1.2.768-1.956A4.125 4.125 0 0 1 11.625 3.5h3a.625.625 0 1 1 0 1.25h-3A2.875 2.875 0 0 0 8.75 7.625a4.1 4.1 0 0 1-1.313 3.018"/><path d="m5.152 14.25 1.335-1.335A4.376 4.376 0 0 0 10 8.625 2.625 2.625 0 0 1 12.625 6h2a.625.625 0 1 1 0 1.25h-2c-.76 0-1.375.616-1.375 1.375a5.625 5.625 0 0 1-5.625 5.625z"/></svg>`,
};
export const iconStreamInput32: {
  name: 'stream-input-32';
  data: string;
} = {
  name: 'stream-input-32',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24"><path d="M8.4 10.8a7.2 7.2 0 0 1 7.2-7.2h.6a.6.6 0 0 0 0-1.2h-.6a8.4 8.4 0 0 0-8.4 8.4V12A1.2 1.2 0 0 1 6 13.2H4.92l1.196 1.198A2.4 2.4 0 0 0 8.4 12zm-7.8 6a.6.6 0 1 0 0 1.2h4.42l-2.576 2.575a.6.6 0 0 0 .849.85l3.587-3.588a.6.6 0 0 0 0-.875l-3.587-3.587a.6.6 0 0 0-.849.85L5.021 16.8zM12 12.6a5.4 5.4 0 0 1-3.778 5.152 2.24 2.24 0 0 0-.146-1.218A4.2 4.2 0 0 0 10.8 12.6v-1.2A5.4 5.4 0 0 1 16.2 6H21a.6.6 0 0 1 0 1.2h-4.8a4.2 4.2 0 0 0-4.2 4.2zm4.8-1.8a1.2 1.2 0 0 0-1.2 1.2v1.2a8.4 8.4 0 0 1-8.4 8.4h-.6a.6.6 0 1 1 0-1.2h.6a7.2 7.2 0 0 0 7.2-7.2V12a2.4 2.4 0 0 1 2.4-2.4H21a.6.6 0 0 1 0 1.2z"/><path d="M.6 16.8a.6.6 0 0 0 0 1.2h4.42l-2.576 2.575a.6.6 0 0 0 .849.85l3.587-3.588a.6.6 0 0 0 0-.875l-3.587-3.587a.6.6 0 0 0-.849.85L5.021 16.8z"/></svg>`,
};
export const iconStreamInput64: {
  name: 'stream-input-64';
  data: string;
} = {
  name: 'stream-input-64',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="64" height="64"><path fill-rule="evenodd" d="M38.898 37.498a14.4 14.4 0 1 1 20.365 20.365 14.4 14.4 0 0 1-20.365-20.365M49.08 35.08a12.6 12.6 0 1 0 0 25.2 12.6 12.6 0 0 0 0-25.2m0 5.7a.9.9 0 0 1 .9.9v5.1h5.1a.9.9 0 0 1 0 1.8h-5.1v5.1a.9.9 0 0 1-1.8 0v-5.1h-5.1a.9.9 0 0 1 0-1.8h5.1v-5.1a.9.9 0 0 1 .9-.9"/><path fill-rule="evenodd" d="M18.065 44.418 7.984 54.452a.95.95 0 0 1-1.616-.668.94.94 0 0 1 .278-.667l8.492-8.446H.946c-.25 0-.491-.1-.669-.276a.94.94 0 0 1 .67-1.608h14.191l-8.492-8.446a.94.94 0 0 1 .668-1.61.95.95 0 0 1 .67.276L18.07 43.042a.94.94 0 0 1 0 1.371l-.002.002zm-1.35-9.798-1.861-1.854h1.251c1.09 0 2.134-.43 2.904-1.197a4.08 4.08 0 0 0 1.203-2.889v-3.352a22.67 22.67 0 0 1 6.69-16.071A22.9 22.9 0 0 1 43.056 2.6h1.684c.25 0 .492.1.67.276a.94.94 0 0 1-.67 1.608h-1.684a21 21 0 0 0-14.814 6.105 20.8 20.8 0 0 0-6.136 14.74v3.351a5.95 5.95 0 0 1-1.656 4.118 6 6 0 0 1-3.696 1.818zm6.445 9.056-.003-.116a7 7 0 0 0-.273-1.737l-.019-.066.064-.029a12.5 12.5 0 0 0 5.16-4.272 12.43 12.43 0 0 0 2.23-7.1v-3.352c0-3.806 1.519-7.455 4.223-10.146a14.46 14.46 0 0 1 10.197-4.203h13.475a.95.95 0 0 1 .946.942.94.94 0 0 1-.946.942H44.739a12.56 12.56 0 0 0-8.859 3.651 12.43 12.43 0 0 0-3.67 8.814v3.352c0 3.052-.978 6.026-2.792 8.487a14.4 14.4 0 0 1-6.15 4.789zm18.807-7.68-.034.017a13.5 13.5 0 0 0-2.07 1.403l-.191.158.063-.24a20.7 20.7 0 0 0 .69-5.302V28.68a5.95 5.95 0 0 1 1.757-4.221 6 6 0 0 1 4.241-1.748h11.79a.94.94 0 1 1 0 1.884h-11.79c-1.089 0-2.134.43-2.904 1.196a4.08 4.08 0 0 0-1.202 2.889v3.352c0 1.325-.117 2.638-.343 3.925l-.007.038Zm-6.847 9.9-.029.246a13.4 13.4 0 0 0-.056 2.488l.002.038-.028.026a22.9 22.9 0 0 1-15.535 6.066H17.79a.95.95 0 0 1-.67-.276.94.94 0 0 1 .67-1.608h1.684a21 21 0 0 0 15.479-6.797z"/></svg>`,
};
export const iconStreamMultiple24: {
  name: 'stream-multiple-24';
  data: string;
} = {
  name: 'stream-multiple-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M12.97 1.22a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06L14.19 5H14a5.25 5.25 0 0 0-5.25 5.25v3A2.75 2.75 0 0 1 6 16H3a.75.75 0 0 1 0-1.5h3c.69 0 1.25-.56 1.25-1.25v-3A6.75 6.75 0 0 1 14 3.5h.19l-1.22-1.22a.75.75 0 0 1 0-1.06m4.5 7a.75.75 0 0 1 1.06 0l2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5a.75.75 0 1 1-1.06-1.06L18.69 12H17c-.69 0-1.25.56-1.25 1.25v1A8.75 8.75 0 0 1 7 23H6a.75.75 0 0 1 0-1.5h1a7.25 7.25 0 0 0 7.25-7.25v-1A2.75 2.75 0 0 1 17 10.5h1.69l-1.22-1.22a.75.75 0 0 1 0-1.06"/><path fill-rule="evenodd" d="M12.97 9.28a.75.75 0 0 1 0 1.061c-.5.5-.72 1.274-.72 1.98v1.586a5.75 5.75 0 0 1-5.75 5.75H4a.75.75 0 0 1 0-1.5h2.5a4.25 4.25 0 0 0 4.25-4.25V12.32c0-1.104.378-2.26 1.159-3.04a.75.75 0 0 1 1.06 0Z"/></svg>`,
};
export const iconStreamOutput16: {
  name: 'stream-output-16';
  data: string;
} = {
  name: 'stream-output-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M11.325 4.75A2.875 2.875 0 0 0 8.45 7.625a4.125 4.125 0 0 1-4.125 4.125h-2.5a.625.625 0 1 1 0-1.25h2.5A2.875 2.875 0 0 0 7.2 7.625 4.125 4.125 0 0 1 11.325 3.5h2.49l-1.332-1.333a.625.625 0 1 1 .884-.884l2.4 2.4a.625.625 0 0 1 0 .884l-2.4 2.4a.625.625 0 0 1-.884-.884l1.333-1.333z"/><path d="M11.334 6.194c-.09.43-.002.891.261 1.265a1.37 1.37 0 0 0-.645 1.166 5.625 5.625 0 0 1-5.625 5.625h-3.5a.625.625 0 1 1 0-1.25h3.5A4.375 4.375 0 0 0 9.7 8.625c0-1.1.675-2.04 1.634-2.431M10.325 2.25A4.375 4.375 0 0 0 5.95 6.625 2.625 2.625 0 0 1 3.325 9.25a.625.625 0 1 1 0-1.25C4.085 8 4.7 7.384 4.7 6.625A5.625 5.625 0 0 1 10.325 1a.625.625 0 0 1 0 1.25"/></svg>`,
};
export const iconStreamTableInput16: {
  name: 'stream-table-input-16';
  data: string;
} = {
  name: 'stream-table-input-16',
  data: `<svg width="17" height="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M12.692 13.959A1.96 1.96 0 0 0 14.65 12V4a1.96 1.96 0 0 0-1.958-1.958H7.025A1.96 1.96 0 0 0 5.067 4v1.334a.625.625 0 0 0 1.25 0V4a.71.71 0 0 1 .708-.708h5.667A.71.71 0 0 1 13.4 4v8a.71.71 0 0 1-.708.709H7.025A.71.71 0 0 1 6.317 12v-1.333a.625.625 0 0 0-1.25 0V12a1.96 1.96 0 0 0 1.958 1.959zm-3.225-8.4a.625.625 0 0 0-.884.883l.933.933H2.525a.625.625 0 0 0 0 1.25h6.991l-.933.933a.625.625 0 0 0 .884.884l2-2a.625.625 0 0 0 0-.884z"/></svg>`,
};
export const iconStreamTableOutput16: {
  name: 'stream-table-output-16';
  data: string;
} = {
  name: 'stream-table-output-16',
  data: `<svg width="17" height="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M2.349 2.615a1.96 1.96 0 0 1 1.384-.573H8.4A1.96 1.96 0 0 1 10.358 4v1.333a.625.625 0 0 1-1.25 0V4a.71.71 0 0 0-.708-.708H3.733A.71.71 0 0 0 3.025 4v8a.71.71 0 0 0 .708.708H8.4A.71.71 0 0 0 9.108 12v-1.333a.625.625 0 1 1 1.25 0V12A1.96 1.96 0 0 1 8.4 13.958H3.733A1.96 1.96 0 0 1 1.775 12V4c0-.52.206-1.017.574-1.385m9.609 2.943a.625.625 0 0 1 .884 0l2 2a.625.625 0 0 1 0 .884l-2 2a.625.625 0 1 1-.884-.884l.933-.933H6.4a.625.625 0 0 1 0-1.25h6.49l-.932-.933a.625.625 0 0 1 0-.884"/></svg>`,
};
export const iconSuccess16: {
  name: 'success-16';
  data: string;
} = {
  name: 'success-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M8 1.375a6.625 6.625 0 1 0 0 13.25 6.625 6.625 0 0 0 0-13.25m-2.058 1.66a5.375 5.375 0 1 1 4.114 9.93 5.375 5.375 0 0 1-4.114-9.93m4.5 4.074a.625.625 0 1 0-.885-.884L7.333 8.45l-.892-.892a.625.625 0 1 0-.884.884l1.334 1.333c.244.244.64.244.884 0L10.44 7.11Z"/></svg>`,
};
export const iconSuccess24: {
  name: 'success-24';
  data: string;
} = {
  name: 'success-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M8.269 2.992a9.75 9.75 0 1 1 7.462 18.016A9.75 9.75 0 0 1 8.27 2.992ZM12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5"/><path fill-rule="evenodd" d="M15.53 9.47a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06L11 12.94l3.47-3.47a.75.75 0 0 1 1.06 0"/></svg>`,
};
export const iconSuccess48: {
  name: 'success-48';
  data: string;
} = {
  name: 'success-48',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48"><path fill-rule="evenodd" d="M7.185 30.965a18.2 18.2 0 1 1 33.629-13.93 18.2 18.2 0 0 1-33.629 13.93M4 24a20 20 0 1 0 40 0 20 20 0 0 0-40 0m27.303-3.808a.9.9 0 0 0-1.273-1.273l-8.252 8.253-3.808-3.808a.9.9 0 1 0-1.273 1.272l4.444 4.445a.9.9 0 0 0 1.273 0l8.89-8.89Z"/></svg>`,
};
export const iconSuccessFilled16: {
  name: 'success-filled-16';
  data: string;
} = {
  name: 'success-filled-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path d="M11.333 2.227a6.667 6.667 0 1 1-9.996 5.99L1.333 8l.004-.216a6.667 6.667 0 0 1 9.996-5.557m-.862 3.968a.67.67 0 0 0-.88-.055l-.062.055L7.333 8.39l-.862-.861-.062-.056a.667.667 0 0 0-.936.936l.056.062 1.333 1.334.063.055a.67.67 0 0 0 .817 0l.063-.055 2.666-2.667.056-.063a.67.67 0 0 0-.056-.88"/></svg>`,
};
export const iconSuccessFilled24: {
  name: 'success-filled-24';
  data: string;
} = {
  name: 'success-filled-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M17 3.34a10 10 0 1 1-14.995 8.984L2 12l.005-.324A10 10 0 0 1 17 3.34m-1.293 5.953a1 1 0 0 0-1.32-.083l-.094.083L11 12.585l-1.293-1.292-.094-.083a1 1 0 0 0-1.403 1.403l.083.094 2 2 .094.083a1 1 0 0 0 1.226 0l.094-.083 4-4 .083-.094a1 1 0 0 0-.083-1.32"/></svg>`,
};
export const iconTriangleDown24: {
  name: 'triangle-down-24';
  data: string;
} = {
  name: 'triangle-down-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="m7.413 11.382 3.607 3.607c.543.543 1.42.543 1.963 0l3.607-3.607c.878-.878.251-2.382-.988-2.382H8.388c-1.24 0-1.852 1.504-.975 2.382"/></svg>`,
};
export const iconUserCheck24: {
  name: 'user-check-24';
  data: string;
} = {
  name: 'user-check-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24"><path fill-rule="evenodd" d="M9.339 3.641a4.75 4.75 0 1 1 6.717 6.718A4.75 4.75 0 0 1 9.34 3.64Zm3.358.109a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 0 0 0-6.5m-2 12A3.25 3.25 0 0 0 7.447 19v2a.75.75 0 0 1-1.5 0v-2a4.75 4.75 0 0 1 4.75-4.75h4a.75.75 0 0 1 0 1.5zm11.53.72a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 1 1 1.06-1.06l1.47 1.47 3.47-3.47a.75.75 0 0 1 1.06 0"/></svg>`,
};
export const iconWarning16: {
  name: 'warning-16';
  data: string;
} = {
  name: 'warning-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"><path fill-rule="evenodd" d="M7.066 1.398a1.9 1.9 0 0 1 2.56.672v.002l5.41 9.033a1.9 1.9 0 0 1-1.625 2.85H2.588a1.9 1.9 0 0 1-1.625-2.85l.005-.01L6.36 2.09a1.9 1.9 0 0 1 .705-.692ZM8 2.404a.65.65 0 0 0-.555.311l-5.4 9.018a.65.65 0 0 0 .555.973h10.8a.65.65 0 0 0 .556-.973l-5.4-9.016a.65.65 0 0 0-.557-.313Zm0 2.971c.345 0 .625.28.625.625v2.667a.625.625 0 1 1-1.25 0V6c0-.345.28-.625.625-.625m-.625 5.292c0-.345.28-.625.625-.625h.007a.625.625 0 1 1 0 1.25H8a.625.625 0 0 1-.625-.625"/></svg>`,
};
export const iconWarning24: {
  name: 'warning-24';
  data: string;
} = {
  name: 'warning-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill-rule="evenodd" d="M10.692 2.26a2.664 2.664 0 0 1 3.586.941l.002.004 8.113 13.546a2.665 2.665 0 0 1-2.277 3.995H3.885a2.663 2.663 0 0 1-2.278-3.996l.006-.01L9.706 3.229a2.66 2.66 0 0 1 .987-.968ZM12 3.419a1.16 1.16 0 0 0-.994.558L2.904 17.505a1.164 1.164 0 0 0 .994 1.74h16.204a1.163 1.163 0 0 0 .994-1.74l-8.1-13.526-.001-.002a1.16 1.16 0 0 0-.995-.56ZM11.25 9a.75.75 0 0 1 .75-.75h.01a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75m-1 3a.75.75 0 0 1 .75-.75h1a.75.75 0 0 1 .75.75v3.25H13a.75.75 0 0 1 0 1.5h-1a.75.75 0 0 1-.75-.75v-3.25H11a.75.75 0 0 1-.75-.75"/></svg>`,
};
export const iconWarningFilled16: {
  name: 'warning-filled-16';
  data: string;
} = {
  name: 'warning-filled-16',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="17" height="16"><path d="M15.776 12.69 9.496 1.834a1.714 1.714 0 0 0-2.971 0L.245 12.69a1.707 1.707 0 0 0 1.48 2.571h12.572a1.707 1.707 0 0 0 1.479-2.571m-8.337-6a.572.572 0 0 1 1.143 0v2.858a.571.571 0 1 1-1.143 0zm.572 6.286a.857.857 0 1 1 0-1.714.857.857 0 0 1 0 1.714"/></svg>`,
};
export const iconWarningFilled24: {
  name: 'warning-filled-24';
  data: string;
} = {
  name: 'warning-filled-24',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22.677 17.851 14.044 3.162a2.34 2.34 0 0 0-.864-.85 2.39 2.39 0 0 0-2.36 0 2.34 2.34 0 0 0-.863.85l-8.633 14.69a2.28 2.28 0 0 0-.011 2.32c.207.353.504.646.863.85.36.203.767.31 1.18.308h17.288a2.37 2.37 0 0 0 1.18-.308 2.33 2.33 0 0 0 .864-.85 2.28 2.28 0 0 0-.01-2.32ZM11.215 9.734c0-.206.082-.402.23-.547a.79.79 0 0 1 1.111 0c.148.145.23.341.23.547v3.865a.77.77 0 0 1-.23.547.79.79 0 0 1-1.111 0 .77.77 0 0 1-.23-.547zM12 18.238c-.234 0-.461-.068-.655-.196a1.17 1.17 0 0 1-.434-.52 1.14 1.14 0 0 1 .255-1.264 1.2 1.2 0 0 1 1.284-.251c.216.087.4.236.53.427a1.146 1.146 0 0 1-.147 1.464 1.2 1.2 0 0 1-.833.34"/></svg>`,
};
export type SeuIcon =
  | 'add-16'
  | 'add-24'
  | 'add-manually-24'
  | 'add-user-24'
  | 'archive-16'
  | 'arrow-down-16'
  | 'arrow-right-16'
  | 'bell-24'
  | 'book-24'
  | 'bookmark-16'
  | 'bookmark-24'
  | 'bookmark-filled-24'
  | 'bookmark-off-16'
  | 'bookmark-off-24'
  | 'box-24'
  | 'calculate-16'
  | 'calculate-24'
  | 'call-16'
  | 'changelog-24'
  | 'check-16'
  | 'chevron-down-16'
  | 'chevron-down-24'
  | 'chevron-left-16'
  | 'chevron-left-24'
  | 'chevron-right-16'
  | 'chevron-right-24'
  | 'chevron-up-16'
  | 'chevron-up-24'
  | 'chimney-24'
  | 'circle-add-16'
  | 'circle-add-24'
  | 'circle-added-16'
  | 'circle-chevron-up-24'
  | 'circle-chevron-up-filled-24'
  | 'circle-close-16'
  | 'circle-close-24'
  | 'circle-remove-16'
  | 'circle-removed-16'
  | 'close-16'
  | 'close-24'
  | 'comment-16'
  | 'contact-24'
  | 'critical-warning-16'
  | 'dashboard-24'
  | 'delete-16'
  | 'delete-24'
  | 'documentation-24'
  | 'drag-24'
  | 'drop-24'
  | 'duplicate-16'
  | 'duplicate-24'
  | 'edit-16'
  | 'emission-limit-24'
  | 'empty-default-32'
  | 'empty-state-32'
  | 'equal-lower-24'
  | 'error-16'
  | 'error-24'
  | 'error-filled-16'
  | 'error-filled-24'
  | 'export-16'
  | 'export-24'
  | 'fan-24'
  | 'fileinfo-24'
  | 'fog-24'
  | 'folder-16'
  | 'folder-24'
  | 'fullscreen-off-24'
  | 'fullscreen-on-24'
  | 'gas-24'
  | 'global-settings-24'
  | 'goal-24'
  | 'greater-24'
  | 'grid-24'
  | 'home-outline-16'
  | 'home-outline-24'
  | 'import-24'
  | 'info-16'
  | 'info-24'
  | 'info-filled-16'
  | 'info-filled-24'
  | 'info-triangle-24'
  | 'info-triangle-filled-16'
  | 'info-triangle-filled-24'
  | 'knowledgebase-24'
  | 'layers-24'
  | 'liquid-24'
  | 'liquid-gas-24'
  | 'list-24'
  | 'mail-16'
  | 'menu-16'
  | 'menu-dots-24'
  | 'minimise-24'
  | 'opex-24'
  | 'orders-24'
  | 'outbreak-16'
  | 'outbreak-24'
  | 'puzzle-24'
  | 'refresh-16'
  | 'request-24'
  | 'reset-16'
  | 'save-16'
  | 'save-24'
  | 'search-16'
  | 'search-24'
  | 'share-16'
  | 'share-24'
  | 'slider-24'
  | 'solid-24'
  | 'stream-input-16'
  | 'stream-input-32'
  | 'stream-input-64'
  | 'stream-multiple-24'
  | 'stream-output-16'
  | 'stream-table-input-16'
  | 'stream-table-output-16'
  | 'success-16'
  | 'success-24'
  | 'success-48'
  | 'success-filled-16'
  | 'success-filled-24'
  | 'triangle-down-24'
  | 'user-check-24'
  | 'warning-16'
  | 'warning-24'
  | 'warning-filled-16'
  | 'warning-filled-24';
export interface SeuIconInterface {
  name: SeuIcon;
  data: string;
}
export type SeuIconInterfaceNameSubset<T extends Readonly<SeuIconInterface[]>> =
  T[number]['name'];
export const completeIconSet = [
  iconAdd16,
  iconAdd24,
  iconAddManually24,
  iconAddUser24,
  iconArchive16,
  iconArrowDown16,
  iconArrowRight16,
  iconBell24,
  iconBook24,
  iconBookmark16,
  iconBookmark24,
  iconBookmarkFilled24,
  iconBookmarkOff16,
  iconBookmarkOff24,
  iconBox24,
  iconCalculate16,
  iconCalculate24,
  iconCall16,
  iconChangelog24,
  iconCheck16,
  iconChevronDown16,
  iconChevronDown24,
  iconChevronLeft16,
  iconChevronLeft24,
  iconChevronRight16,
  iconChevronRight24,
  iconChevronUp16,
  iconChevronUp24,
  iconChimney24,
  iconCircleAdd16,
  iconCircleAdd24,
  iconCircleAdded16,
  iconCircleChevronUp24,
  iconCircleChevronUpFilled24,
  iconCircleClose16,
  iconCircleClose24,
  iconCircleRemove16,
  iconCircleRemoved16,
  iconClose16,
  iconClose24,
  iconComment16,
  iconContact24,
  iconCriticalWarning16,
  iconDashboard24,
  iconDelete16,
  iconDelete24,
  iconDocumentation24,
  iconDrag24,
  iconDrop24,
  iconDuplicate16,
  iconDuplicate24,
  iconEdit16,
  iconEmissionLimit24,
  iconEmptyDefault32,
  iconEmptyState32,
  iconEqualLower24,
  iconError16,
  iconError24,
  iconErrorFilled16,
  iconErrorFilled24,
  iconExport16,
  iconExport24,
  iconFan24,
  iconFileinfo24,
  iconFog24,
  iconFolder16,
  iconFolder24,
  iconFullscreenOff24,
  iconFullscreenOn24,
  iconGas24,
  iconGlobalSettings24,
  iconGoal24,
  iconGreater24,
  iconGrid24,
  iconHomeOutline16,
  iconHomeOutline24,
  iconImport24,
  iconInfo16,
  iconInfo24,
  iconInfoFilled16,
  iconInfoFilled24,
  iconInfoTriangle24,
  iconInfoTriangleFilled16,
  iconInfoTriangleFilled24,
  iconKnowledgebase24,
  iconLayers24,
  iconLiquid24,
  iconLiquidGas24,
  iconList24,
  iconMail16,
  iconMenu16,
  iconMenuDots24,
  iconMinimise24,
  iconOpex24,
  iconOrders24,
  iconOutbreak16,
  iconOutbreak24,
  iconPuzzle24,
  iconRefresh16,
  iconRequest24,
  iconReset16,
  iconSave16,
  iconSave24,
  iconSearch16,
  iconSearch24,
  iconShare16,
  iconShare24,
  iconSlider24,
  iconSolid24,
  iconStreamInput16,
  iconStreamInput32,
  iconStreamInput64,
  iconStreamMultiple24,
  iconStreamOutput16,
  iconStreamTableInput16,
  iconStreamTableOutput16,
  iconSuccess16,
  iconSuccess24,
  iconSuccess48,
  iconSuccessFilled16,
  iconSuccessFilled24,
  iconTriangleDown24,
  iconUserCheck24,
  iconWarning16,
  iconWarning24,
  iconWarningFilled16,
  iconWarningFilled24,
];
